/* TurnOrder — reper de referință de performanță (08 aug. 2026).
   RO: Măsurătoare de bază înainte de optimizări: 9,73 MB transferați / 241 cereri,
       din care 12 imagini de catalog = 7,36 MB. Lighthouse mobil: 39, LCP 4,3 s.
       Acest comentariu nu are efect funcțional; servește ca punct de comparație.
   EN: Performance baseline before optimisation: 9.73 MB / 241 requests, of which
       12 catalogue images = 7.36 MB. Mobile Lighthouse: 39, LCP 4.3 s.
       This comment has no functional effect; it is a comparison marker. */
/* ================= CONFIGURATION ================= */

/* ── DATORIE TEHNICĂ (item 4): logare unică a erorilor înghițite ──────────────
   În loc de `catch (e) {}` mut, folosim:
     • logError(ctx, err)                    → best-effort: doar consolă, NU aruncă.
     • logError(ctx, err, { notify:true, msg }) → + showNotification de eroare (bug real).
     • logError(ctx, err, { report:true })   → + trimite (best-effort, throttled) la
                                                tabelul client_errors pentru triaj (owner platformă).
   §9: NU trimitem PII/secrete — doar context scurt + mesajul erorii (truncat).
   Definit în app-core.js (primul script) → disponibil global, devreme. ── */
(function () {
    var _errThrottle = {};         // ctx -> ultimul timestamp trimis (anti-flood)
    var _ERR_WINDOW_MS = 60000;    // max 1 raport / context / minut

    function _safeMsg(err) {
        try {
            if (err == null) return '';
            var m = (err && err.message != null) ? String(err.message) : String(err);
            return m.slice(0, 300);
        } catch (e) { return ''; }
    }

    window.reportClientError = function (ctx, err) {
        try {
            var now = Date.now();
            var key = String(ctx || '?');
            if (_errThrottle[key] && (now - _errThrottle[key]) < _ERR_WINDOW_MS) return;
            _errThrottle[key] = now;
            if (typeof sb === 'undefined' || !sb) return;
            if (typeof state === 'undefined' || !state || !state.currentUser) return;
            var row = {
                ctx: key.slice(0, 120),
                message: _safeMsg(err),
                url: (function () { try { return String(location.pathname || '').slice(0, 200); } catch (e) { return null; } })()
            };
            /* fire-and-forget; NU așteptăm, NU aruncăm, degradare grațioasă la RLS/offline */
            sb.from('client_errors').insert(row).then(function () {}, function () {});
        } catch (e) { /* sink indisponibil → rămâne doar logul din consolă */ }
    };

    /* ── SENTRY (aditiv, best-effort) ─────────────────────────────────────────
       RO: dacă SDK-ul Sentry e încărcat, orice `logError` lasă o URMĂ (breadcrumb)
           — gratuit, nu consumă cota. DOAR erorile marcate deliberat ca importante
           (`report:true` / `notify:true`) se trimit ca eveniment, cu același throttle
           de 1/context/minut ca `reportClientError`. Dacă Sentry lipsește (adblocker,
           CDN picat), nu se întâmplă absolut nimic — comportamentul rămâne identic.
       EN: adds a breadcrumb for every logError; sends an event only for deliberate
           reports. No-op when the Sentry SDK is absent.
       ⚠ NU înlocuiește `reportClientError`/`client_errors` (§21.6) — coexistă. ── */
    function _toSentry(ctx, err, deliberate) {
        try {
            var S = window.Sentry;
            if (!S) return;
            var key = String(ctx || '?').slice(0, 120);
            var msg = _safeMsg(err);

            if (typeof S.addBreadcrumb === 'function') {
                S.addBreadcrumb({ category: 'logError', level: 'warning', message: key + ' | ' + msg });
            }
            if (!deliberate || typeof S.captureException !== 'function') return;

            /* Throttle separat (prefix 'S:') ca să nu interfereze cu cel al `client_errors`. */
            var tk = 'S:' + key;
            var now = Date.now();
            if (_errThrottle[tk] && (now - _errThrottle[tk]) < _ERR_WINDOW_MS) return;
            _errThrottle[tk] = now;

            S.captureException((err instanceof Error) ? err : new Error(msg || key), {
                tags: { ctx: key },
                level: 'error'
            });
        } catch (e) { /* Sentry nu are voie să rupă niciodată logarea de bază. */ }
    }

    window.logError = function (ctx, err, opts) {
        opts = opts || {};
        try { console.warn('[TO]', ctx || '?', _safeMsg(err)); } catch (e) {}
        _toSentry(ctx, err, !!(opts.report || opts.notify));
        try {
            if (opts.notify && typeof showNotification === 'function') {
                var msg = opts.msg || ((typeof t === 'function') ? t('err.generic') : 'A apărut o eroare.');
                showNotification(msg, 'error');
            }
        } catch (e) {}
        if (opts.report) window.reportClientError(ctx, err);
    };
})();

/* ─── ÎNCĂRCARE LA CERERE A LIBRĂRIILOR GRELE DE EXPORT (Batch 2, perf) ────────
   RO: `jspdf`, `jspdf-autotable`, `xlsx` și `html2canvas` erau încărcate din CDN
       la FIECARE pornire a aplicației, deși majoritatea utilizatorilor nu exportă
       niciodată nimic. Măsurat 08.08.2026: blocau randarea ~2.480 ms pe mobil.
       Acum se încarcă doar când se apasă efectiv un buton care are nevoie de ele.
       Tiparul e cel deja folosit de `_shareCard` pentru html2canvas — doar unificat.
       Fiecare librărie se încarcă O SINGURĂ DATĂ: promisiunea se memorează, deci
       al doilea export e instant. Eșecul (adblocker, rețea proastă) respinge
       promisiunea, iar apelantul afișează `t('gdpr.libMissing')` și se oprește curat.
   EN: heavy export libraries are no longer eager-loaded from CDN; they are fetched
       on first use and memoised. Failure rejects, callers show a translated notice. */
(function () {
    var _libs = {
        /* Ordinea contează: autotable e un plugin peste jspdf. */
        jspdf: [
            'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js',
            'https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.5.31/jspdf.plugin.autotable.min.js'
        ],
        xlsx: ['https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js'],
        html2canvas: ['https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js']
    };
    /* Verificare „e deja disponibilă?\" — acoperă și cazul în care o extensie sau
       un alt script a adus librăria pe altă cale. */
    var _ready = {
        jspdf: function () { return !!(window.jspdf && window.jspdf.jsPDF); },
        xlsx: function () { return !!(window.XLSX && window.XLSX.utils); },
        html2canvas: function () { return typeof window.html2canvas === 'function'; }
    };
    var _cache = {};   /* nume -> Promise (memoizare: o singură încărcare) */

    function _loadScript(src) {
        return new Promise(function (resolve, reject) {
            var s = document.createElement('script');
            s.src = src;
            s.async = true;
            s.onload = function () { resolve(); };
            s.onerror = function () { reject(new Error('nu s-a putut încărca ' + src)); };
            (document.head || document.documentElement).appendChild(s);
        });
    }

    /* Încarcă (o singură dată) librăria cerută. Întoarce o promisiune. */
    window.ensureLib = function (name) {
        try {
            var urls = _libs[name];
            if (!urls) return Promise.reject(new Error('librărie necunoscută: ' + name));
            if (_ready[name] && _ready[name]()) return Promise.resolve();
            if (_cache[name]) return _cache[name];

            /* Secvențial, nu paralel: autotable are nevoie de jspdf deja prezent. */
            var p = urls.reduce(function (chain, u) {
                return chain.then(function () { return _loadScript(u); });
            }, Promise.resolve());

            /* La eșec ștergem memoizarea, ca o a doua încercare să fie posibilă
               (utilizatorul poate reveni pe o rețea mai bună). */
            p = p.catch(function (e) {
                _cache[name] = null;
                if (typeof window.logError === 'function') window.logError('ensureLib:' + name, e);
                throw e;
            });
            _cache[name] = p;
            return p;
        } catch (e) {
            return Promise.reject(e);
        }
    };

    /* Ajutor pentru apelanți: încarcă și, la eșec, anunță utilizatorul în limba lui
       și întoarce `false` — ca apelantul să facă doar `if (!await ensureLibOrWarn(x)) return;` */
    window.ensureLibOrWarn = function (name) {
        return window.ensureLib(name).then(function () { return true; }).catch(function () {
            try {
                var msg = (typeof t === 'function') ? t('gdpr.libMissing') : 'Export components failed to load. Reload the page and try again.';
                if (typeof showNotification === 'function') showNotification(msg, 'error');
            } catch (e) { }
            return false;
        });
    };
})();

/* ─── ÎNCĂRCARE LA CERERE A CLOUDFLARE TURNSTILE (Batch 1b, perf · §54) ────────
   RO: scutul anti-bot de la login era încărcat din `index.html` la FIECARE pornire,
       inclusiv pentru utilizatorii DEJA LOGAȚI, care nu văd niciodată formularul de
       autentificare. Turnstile scanează singur DOM-ul după `.cf-turnstile` când se
       încarcă și NU îi pasă că `#loginScreen` e ascuns — deci randa complet widget-ul
       degeaba. Măsurat 22.08.2026, utilizator logat pe Dashboard: `api.js` 27,6 kB
       (302 + 200 = DOUĂ cereri) + iframe-ul `flexible?lang=auto` 103 kB + 6 cereri
       auxiliare = **133 kB și 9 cereri, complet inutile**.
       Acum se încarcă abia când `showLogin()` deschide efectiv formularul. Randarea
       widget-ului rămâne AUTOMATĂ (Turnstile găsește singur `.cf-turnstile` la
       încărcare, iar în acel moment cardul de login e deja vizibil) — nu folosim
       `render=explicit`, ca să nu dublăm o logică pe care biblioteca o face corect.
   EN: the anti-bot shield was eager-loaded on every startup, even for already
       signed-in users who never see the login form: 133 kB and 9 requests wasted
       (measured 22 Aug 2026). It is now fetched when `showLogin()` actually opens the
       form; auto-rendering still applies because the card is visible by then. */
(function () {
    var _tsLoad = null;   /* Promise memoizată: o singură încărcare per sesiune. */

    /* Încarcă scriptul Turnstile o singură dată. Întoarce Promise<boolean>:
       `true` = scriptul e disponibil, `false` = a eșuat (adblocker, rețea).
       ⚠ NU respinge niciodată — apelantul nu trebuie să fie obligat să prindă erori
       pe un drum critic (login). */
    window.ensureTurnstile = function () {
        if (_tsLoad) return _tsLoad;
        _tsLoad = new Promise(function (resolve) {
            try {
                if (window.turnstile) { resolve(true); return; }
                var s = document.createElement('script');
                s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
                s.async = true;
                s.defer = true;
                s.onload = function () { resolve(true); };
                /* La eșec ștergem memoizarea, ca o a doua încercare (rețea revenită)
                   să fie posibilă — același tipar ca la `ensureLib`. */
                s.onerror = function () {
                    _tsLoad = null;
                    if (typeof window.logError === 'function') window.logError('ensureTurnstile', new Error('turnstile script blocked'));
                    resolve(false);
                };
                (document.head || document.documentElement).appendChild(s);
            } catch (e) {
                _tsLoad = null;
                if (typeof window.logError === 'function') window.logError('ensureTurnstile', e);
                resolve(false);
            }
        });
        return _tsLoad;
    };

    /* ─── STAREA WIDGET-ULUI (Batch 1b-fix, aug. 2026) ───────────────────────
       RO: DEFECT REAL, reprodus pe 3G: Turnstile poate hotărî că vrea o BIFĂ
           MANUALĂ de la utilizator. Când face asta, tokenul NU apare niciodată
           singur — deci `turnstileToken()` aștepta degeaba tot răgazul, trimitea
           un șir gol, iar serverul răspundea „Verificarea de securitate a eșuat".
           Utilizatorul credea că a greșit el ceva, deși trebuia doar să bifeze.
           Steagurile de mai jos sunt setate de callback-urile pe care Turnstile le
           cheamă singur (declarate ca `data-*-callback` pe widget, în index.html).
           Cu ele, așteptarea se OPREȘTE devreme când e clar că nu are ce aștepta,
           iar `login()` poate spune exact ce trebuie făcut.
       EN: real defect reproduced on 3G — Turnstile may require a manual tick, in
           which case no amount of waiting produces a token. These flags let us stop
           waiting early and show "tick the box" instead of "the check failed". */
    var _tsNeedsTick = false;   /* widget-ul cere interacțiune umană */
    var _tsErrored = false;     /* widget-ul a raportat eroare (rețea, cheie, blocare) */

    /* Turnstile cheamă funcțiile astea SINGUR, după nume, de pe `window`.
       ⚠ NU le redenumi fără să schimbi și `data-*-callback` din index.html.
       EN: Turnstile calls these by name off `window`; keep in sync with index.html. */
    window.onTurnstileToken = function () { _tsNeedsTick = false; _tsErrored = false; };
    window.onTurnstileInteractive = function () { _tsNeedsTick = true; };
    window.onTurnstileError = function () { _tsErrored = true; };
    window.onTurnstileExpired = function () { _tsNeedsTick = false; };

    /* Ce trebuie spus utilizatorului când tokenul lipsește — TREI stări, nu două:
       'tick'    → widget-ul așteaptă o bifă de la el (nu apare nimic de la sine);
       'failed'  → widget-ul a raportat eroare (blocat de adblocker, rețea moartă);
       'pending' → widget-ul lucrează, dar n-a terminat („Verifying…").
       ⚠ DE CE 'pending' EXISTĂ (defect real, 3G, aug. 2026): prima versiune avea doar
       două stări, deci un widget aflat încă în „Verifying…" era raportat drept EȘEC.
       Utilizatorul vedea „Verificarea de securitate a eșuat" în timp ce, pe ecran,
       scutul se învârtea liniștit — mesaj fals și derutant. Nu eșuase nimic; doar nu
       apucase să termine.
       EN: three states, not two. The first version reported a still-running widget as a
       failure, which was simply false — it just hadn't finished yet. */
    window.turnstileMissingReason = function () {
        if (_tsErrored) return 'failed';
        if (_tsNeedsTick) return 'tick';
        return 'pending';
    };

    /* Resetare a stării odată cu widget-ul, ca o a doua încercare să pornească curat. */
    window.turnstileReset = function () {
        _tsNeedsTick = false;
        _tsErrored = false;
        try { if (window.turnstile && typeof window.turnstile.reset === 'function') window.turnstile.reset(); } catch (e) { }
    };

    /* Așteaptă tokenul CAPTCHA, cel mult `timeoutMs`. Întoarce Promise<string>
       (șir gol dacă nu a apărut).
       ⚠ DE CE E OBLIGATORIU: `TURNSTILE_SECRET` ESTE setat pe Edge Function-ul
       `hybrid-login`, deci serverul CHIAR verifică tokenul — un token gol = login
       respins cu `captcha_failed`. Înainte, scriptul pornea odată cu pagina și avea
       secunde bune avans; acum pornește la deschiderea formularului, deci un
       utilizator rapid ar putea apăsa „Conectare" înainte ca widget-ul să producă
       tokenul. Citirea oarbă de dinainte ar fi trimis un șir gol.
       ⚠ Ieșire TIMPURIE (Batch 1b-fix): dacă widget-ul cere bifă manuală sau a dat
       eroare, ne oprim IMEDIAT — nu are rost să ținem omul 20 de secunde degeaba.
       ⚠ `onSlow` (Batch 1b-fix v3): dacă după `slowAfterMs` tot nu avem token, dăm un
       semn de viață APELANTULUI, dar CONTINUĂM să așteptăm. Fără el, utilizatorul
       apăsa „Conectare" și rămânea 20 de secunde în tăcere — inacceptabil. Cu el,
       primește feedback în ~2 s și e conectat automat când tokenul sosește, fără să
       mai apese a doua oară.
       ⚠ BONUS: repară și un defect latent PREEXISTENT — după o încercare eșuată,
       `turnstile.reset()` golește tokenul, deci o a doua apăsare imediată trimitea
       tot un șir gol. Acum se așteaptă tokenul proaspăt.
       EN: waits for the CAPTCHA token (server-side verification IS enabled), bails out
       early when a manual tick or an error makes waiting pointless, signals the caller
       after `slowAfterMs` so the user is not left in silence, and fixes a pre-existing
       bug where an immediate retry after `reset()` sent an empty token. */
    window.turnstileToken = function (timeoutMs, onSlow, slowAfterMs) {
        var limit = (typeof timeoutMs === 'number' && timeoutMs > 0) ? timeoutMs : 20000;
        var slowAt = (typeof slowAfterMs === 'number' && slowAfterMs > 0) ? slowAfterMs : 2000;
        var t0 = Date.now();
        var slowFired = false;
        /* Citire tolerantă: `getResponse()` aruncă dacă widget-ul nu e încă randat. */
        var read = function () {
            try {
                if (window.turnstile && typeof window.turnstile.getResponse === 'function') {
                    return window.turnstile.getResponse() || '';
                }
            } catch (e) { /* widget încă nerandat — normal în primele sute de ms */ }
            return '';
        };
        return new Promise(function (resolve) {
            var first = read();
            if (first) { resolve(first); return; }
            var iv = setInterval(function () {
                var v = read();
                var elapsed = Date.now() - t0;
                /* Oprire timpurie: nu mai are ce să apară de la sine. */
                if (v || _tsNeedsTick || _tsErrored || elapsed >= limit) {
                    clearInterval(iv);
                    resolve(v);
                    return;
                }
                /* Semn de viață, o SINGURĂ dată, fără a întrerupe așteptarea. */
                if (!slowFired && elapsed >= slowAt) {
                    slowFired = true;
                    try { if (typeof onSlow === 'function') onSlow(); } catch (e) { }
                }
            }, 100);
        });
    };
})();

/* ================= COMPRIMAREA IMAGINILOR ÎNAINTE DE ÎNCĂRCARE =============
   RO: Pozele de sesiune și de anunț se trimiteau BRUTE de pe telefon — 3-8 MB
       fiecare, până la 12 respectiv 8 per încărcare. Tiparul de comprimare exista
       deja în proiect (avatare: `FileReader` → `Image` → canvas → `toDataURL`),
       dar copiat de patru ori și potrivit doar pentru data URL-uri de 256 px.
       Aici e extras ca helper unic, care întoarce un FIȘIER, nu un data URL,
       fiindcă încărcarea în Storage are nevoie de conținut binar.

   ⚠ ÎNTOARCE UN `File`, NU UN `Blob`: `uploadSessionPhotos` derivă extensia din
     `f.name.split('.').pop()`. Un `Blob` n-are `name`, deci un PNG păstrat ar fi
     ajuns în bucket cu extensia greșită.

   ⚠ CAPCANELE TRATATE, fiecare cu motivul ei:
     · ORIENTARE EXIF — o poză făcută cu telefonul în portret ajunge ÎNTOARSĂ după
       trecerea prin canvas, fiindcă rotația stă în metadate, nu în pixeli.
       `createImageBitmap(file, {imageOrientation:'from-image'})` o aplică. Fără
       asta, defectul e imediat vizibil și afectează majoritatea pozelor de telefon.
     · PNG CU TRANSPARENȚĂ — convertit la JPEG, fundalul transparent devine NEGRU.
       Verificăm canalul alfa și, dacă există transparență, rămânem pe PNG.
     · DEJA MIC — sub prag ȘI sub `maxPx` ⇒ trimitem originalul. Recomprimarea ar
       degrada calitatea fără niciun câștig.
     · REZULTAT MAI MARE — se întâmplă la capturi de ecran și grafice. Dacă blobul
       comprimat depășește originalul, păstrăm originalul.
     · EȘEC — orice excepție (memorie insuficientă la poze de 48 MP, format exotic)
       întoarce fișierul original. ⛔ POZA NU SE PIERDE NICIODATĂ ÎN TĂCERE.
   EN: single reusable compressor returning a File (not a Blob, since the upload
       path derives the extension from the name). Handles EXIF orientation, PNG
       transparency, already-small files, size regressions, and failures by
       always falling back to the original file. ── */

/* 2048 px / 0.85 — ales pentru ARHIVĂ, nu doar pentru vizionare.
   Pozele de sesiune se revizitează în istoricul clubului, deci 1600/0.8 (bun
   pentru un flux efemer, tipar WhatsApp) ar fi fost prea agresiv: 2048 px rămâne
   clar pe ecrane retina și suportă o mărire rezonabilă, iar 0.85 evită artefactele
   vizibile pe zonele plate (fețe, fundaluri). Tot scade o poză de ~5 MB la câteva
   sute de kB. ⚠ Nu e arhivare la rezoluție NATIVĂ: originalul de la telefon nu se
   păstrează nicăieri. */
window.TO_IMG_MAX_PX = 2048;
window.TO_IMG_QUALITY = 0.85;
window.TO_IMG_SKIP_BELOW = 400 * 1024;   /* sub asta nu merită recomprimat */

function _imgDecode(file) {
    /* `createImageBitmap` cu `from-image` e singura cale care aplică rotația EXIF
       fără să citim manual metadatele. Rezervă: `<img>`, care în browserele
       actuale respectă și el orientarea la randare. */
    if (typeof createImageBitmap === 'function') {
        try {
            return createImageBitmap(file, { imageOrientation: 'from-image' })
                .catch(function () { return _imgDecodeFallback(file); });
        } catch (e) { return _imgDecodeFallback(file); }
    }
    return _imgDecodeFallback(file);
}

function _imgDecodeFallback(file) {
    return new Promise(function (resolve, reject) {
        var url = URL.createObjectURL(file);
        var im = new Image();
        im.onload = function () { resolve(im); };
        im.onerror = function () { try { URL.revokeObjectURL(url); } catch (e) { /* noop */ } reject(new Error('decode')); };
        im.src = url;
    });
}

/* Transparența se verifică prin eșantionare (fiecare al 16-lea pixel): o trecere
   completă peste 4 milioane de pixeli ar bloca firul principal degeaba. */
function _hasAlpha(ctx, w, h) {
    try {
        var d = ctx.getImageData(0, 0, w, h).data;
        for (var i = 3; i < d.length; i += 64) { if (d[i] < 250) return true; }
        return false;
    } catch (e) { return true; }   /* la îndoială, păstrăm PNG-ul */
}

window.compressImage = function (file, maxPx, quality) {
    maxPx = maxPx || window.TO_IMG_MAX_PX;
    quality = quality || window.TO_IMG_QUALITY;
    if (!file || !/^image\//.test(file.type || '')) return Promise.resolve(file);
    /* GIF-urile animate ar deveni un singur cadru — nu le atingem. */
    if (/^image\/gif/.test(file.type)) return Promise.resolve(file);

    return _imgDecode(file).then(function (src) {
        var iw = src.width, ih = src.height;
        if (!iw || !ih) return file;
        var scale = Math.min(1, maxPx / Math.max(iw, ih));
        /* Deja mic ÎN AMBELE sensuri (dimensiune și greutate) ⇒ nu-l atingem. */
        if (scale === 1 && file.size <= window.TO_IMG_SKIP_BELOW) return file;

        var w = Math.max(1, Math.round(iw * scale));
        var h = Math.max(1, Math.round(ih * scale));
        var cv = document.createElement('canvas');
        cv.width = w; cv.height = h;
        var ctx = cv.getContext('2d');
        ctx.drawImage(src, 0, 0, w, h);
        try { if (src.close) src.close(); } catch (e) { /* noop */ }

        var isPng = /^image\/png/.test(file.type);
        var keepPng = isPng && _hasAlpha(ctx, w, h);
        var outType = keepPng ? 'image/png' : 'image/jpeg';

        if (!keepPng) {
            /* Fundal alb sub imagine: apărare în plus dacă eșantionarea a ratat o
               transparență — alb e mult mai puțin șocant decât negru. */
            var tmp = document.createElement('canvas');
            tmp.width = w; tmp.height = h;
            var tctx = tmp.getContext('2d');
            tctx.fillStyle = '#fff'; tctx.fillRect(0, 0, w, h);
            tctx.drawImage(cv, 0, 0);
            cv = tmp;
        }

        return new Promise(function (resolve) {
            cv.toBlob(function (blob) {
                if (!blob || blob.size >= file.size) { resolve(file); return; }   /* nicio îmbunătățire */
                var base = String(file.name || 'photo').replace(/\.[^.]+$/, '');
                var name = base + (keepPng ? '.png' : '.jpg');
                try { resolve(new File([blob], name, { type: outType, lastModified: Date.now() })); }
                catch (e) { resolve(file); }   /* constructorul File lipsește ⇒ originalul */
            }, outType, keepPng ? undefined : quality);
        });
    }).catch(function (e) {
        /* Memorie insuficientă la poze de 48 MP, format neacceptat, orice altceva:
           trimitem originalul. Mai bine o poză mare decât nicio poză. */
        logError('compressImage', e);
        return file;
    });
};

/* ── SECURITATE (R2/R4): escaper HTML global unic. Se folosește la randarea în
   innerHTML a ORICĂRUI text venit de la useri (mesaje, nume, @tag-uri etc.),
   ca să prevină Stored/Reflected XSS. Definit în app-core.js → disponibil global. ── */
window.escHtml = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
};

/* ── SECURITATE (R2/R4b): transformarea adreselor web în linkuri, PESTE text DEJA
   ESCAPAT. Aici se generează HTML din conținut scris de utilizatori, deci e cea
   mai sensibilă funcție din proiect.

   ⚠ NUMELE conține „Escaped" INTENȚIONAT: cine o cheamă trebuie să vadă din
     semnătură că intrarea e obligatoriu rezultatul lui `escHtml`. NU primește
     niciodată text brut. Ordinea corectă e `linkifyEscaped(escHtml(x))` —
     invers ar însemna XSS.

   ⚠ LISTĂ ALBĂ, NU LISTĂ NEAGRĂ. Nu „respingem" `javascript:`, `data:`,
     `vbscript:`, `file:` — expresia PORNEȘTE de la `https?://`, deci ele nu sunt
     nici măcar candidate. O listă neagră s-ar putea ocoli (`JaVaScRiPt:`,
     `java\tscript:`, caractere de control interpuse); aici nu există ce ocoli.

   ⚠ De ce e sigur să punem rezultatul și în `href`, și ca text: după `escHtml` nu
     mai există în șir NICIUN caracter `" ' < >` brut — au devenit entități. Clasa
     de caractere de mai jos le exclude oricum, singura entitate acceptată în
     interiorul adresei fiind `&amp;` (frecventă în parametrii de interogare;
     într-un atribut se decodează înapoi în `&`, adică exact adresa originală).

   EN: turns URLs into links over ALREADY-ESCAPED text. Allow-list on `https?://`
       rather than blocking dangerous schemes, so there is nothing to bypass. ── */
window.linkifyEscaped = function (escapedHtml) {
    var s = String(escapedHtml == null ? '' : escapedHtml);
    /* Caractere permise în adresă + `&amp;`. Exclude spațiile și tot ce ar putea
       închide un atribut sau o etichetă. */
    var RE = /\bhttps?:\/\/(?:[A-Za-z0-9\-._~:\/?#\[\]@!$()*+,;=%]|&amp;)+/g;
    return s.replace(RE, function (url) {
        var tail = '';
        /* Punctuația de final ține de frază, nu de adresă: „vezi https://a.com."
           nu trebuie să înghită punctul în link. */
        var m;
        while ((m = /[.,;:!?]$/.exec(url)) && url.length > 9) {
            tail = m[0] + tail;
            url = url.slice(0, -1);
        }
        /* Paranteză de închidere neîmperecheată: „(vezi https://a.com)" — ultima
           paranteză aparține textului. Una ÎMPERECHEATĂ rămâne în adresă, fiindcă
           există linkuri legitime care o conțin (ex. articole de wiki). */
        while (url.slice(-1) === ')' &&
               (url.split(')').length - 1) > (url.split('(').length - 1)) {
            tail = ')' + tail;
            url = url.slice(0, -1);
        }
        /* Trebuie să rămână o adresă reală după curățare, nu doar „https://". */
        if (!/^https?:\/\/[A-Za-z0-9]/.test(url)) return url + tail;
        /* `noopener` e obligatoriu: fără el, pagina deschisă poate manipula
           fereastra noastră prin `window.opener`.
           Clasa `to-link` e pusă AICI, nu la fiecare loc de randare: astfel o
           singură regulă CSS acoperă toate cele patru contexte (chat, anunțuri,
           mesaje private, descriere eveniment) și orice utilizare viitoare. */
        return '<a class="to-link" href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + '</a>' + tail;
    });
};

/* ── SECURITATE (R4b): escaper pentru valori puse într-un string JS DELIMITAT cu '…'
   în interiorul unui atribut HTML delimitat cu "…", ex: onclick="f('${attrJs(x)}')".
   Context dublu: HTML-ul se decodează ÎNAINTE de a rula JS, deci escapăm pe DOUĂ
   niveluri: 1) JS (\\ și ') ca să nu se rupă string-ul; 2) HTML (& " < >) ca să nu
   se iasă din atribut. NU folosi escHtml aici (transformă ' în &#39;, care se decodează
   înapoi în ' și redeschide breakout-ul). ── */
window.attrJs = function (s) {
    return String(s == null ? '' : s)
        .replace(/\\/g, '\\\\')   // JS: backslash întâi
        .replace(/'/g, "\\'")      // JS: ghilimea simplă → \'
        .replace(/&/g, '&amp;')    // HTML: & întâi
        .replace(/"/g, '&quot;')   // HTML: " (previne ieșirea din atribut)
        .replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/\r?\n/g, ' ');   // fără newline-uri în atribut
};

const STORAGE_KEY = "GBGSC_PRO_V3";
// NOTE: Accesul de admin NU mai este controlat de o parolă în cod.
// Se verifică rolul (role === 'admin') din tabela `profiles` din Supabase.
const DEFAULT_CATEGORIES = ["Eurogame", "Ameritrash", "Party", "Cooperativ", "Strategie", "Filler", "Legacy", "Deck Building", "RPG", "Worker Placement", "Engine Building"];
const POINTS_STEP = 0.5;
const SESSION_TYPES = {
    standard: { icon: "fa-dice", color: "var(--accent-primary)", name: "Sesiune Standard" },
    tournament: { icon: "fa-trophy", color: "var(--accent-gold)", name: "Turneu" },
    regular: { icon: "fa-dice", color: "var(--accent-primary)", name: "Sesiune Standard" },
    casual: { icon: "fa-dice", color: "var(--accent-primary)", name: "Sesiune Standard" }
};

/* ================= STATE MANAGEMENT ================= */
let state = {
    version: "3.0",
    users: {},
    currentUser: null,
    members: {},
    games: [],
    catalog: {},
    categories: [...DEFAULT_CATEGORIES],
    polls: [],
    liveSessions: [],   /* §2: sesiunile live DESCHISE ale clubului curent */
    chatMessages: [],
    regulation: {
        version: "1.0",
        lastModified: new Date().toISOString(),
        articles: []
    },
    seasons: [],
    currentSeason: new Date().getFullYear(),
    locations: [],
    audit: [],
    events: [],
    backups: [],
    settings: {
        pointsPerWin: 3,
        pointsPerSecond: 2,
        pointsPerThird: 1,
        pointsPerParticipation: 0.5,
        chatNotifications: true,
        emailNotifications: false,
        theme: "dark",
        language: "ro"
    },
    onlineUsers: {},
    notifications: []
};

let isAdmin = false;
let isMuted = false;
let currentTab = 'dashboard';
/* Deep-link: hash-ul din URL la încărcarea paginii (ex. #polls dintr-un link partajat).
   Îl onorăm O SINGURĂ DATĂ, la primul showMainApp (cold-start). Intrarea ulterioară
   într-un club merge implicit pe Dashboard. */
let _bootHash = '';
try { _bootHash = (window.location.hash || '').replace(/^#/, ''); } catch (e) { logError('_safeMsg', e); }
let _deepLinkHandled = false;
let sessionGuests = [];
let chatInterval;
let onlineInterval;
let currentMonth = new Date().getMonth();
let currentYear = new Date().getFullYear();
let resetCodeTimeout = null;
/* RO: `chatSound` (Audio de pe assets.mixkit.co) a fost ELIMINAT. Sistemul vechi de
       sunet la chat e inactiv din iul. 2026 (§26.5) — nu exista niciun `.play()` în tot
       proiectul — dar `new Audio(url)` declanșa oricum descărcarea fișierului de pe un
       CDN terț la FIECARE încărcare a paginii: request inutil, dependență externă
       necache-abilă offline și IP-ul utilizatorului trimis unui terț nedeclarat în
       politica de confidențialitate. Notificările la mesaje: alegerea pe club, pe cont
       (club-notif.js, v9 8.7-D3; vechiul comutator doar pe dispozitiv, șters 27 oct.).
   EN: removed a dead third-party audio preload that fired on every page load. */

/* ================= INITIALIZATION ================= */
/* Funcția `init()` reală (bazată pe Supabase Auth + Realtime) este definită
   în stratul de integrare Supabase de la finalul scriptului. Aici se găsesc
   doar funcțiile auxiliare folosite de aceasta. */

/* ================= ECRANUL DE ÎNCĂRCARE (#loader) =========================
   RO: DEFECT REPARAT (23 aug. 2026) — `hideLoader()` era chemat pe PRIMA linie
       din `init()` (supabase-integration.js) și avea în plus un `setTimeout` FIX
       de 1000 ms. Nu aștepta NIMIC din aplicație. Cronologia măsurată de tester:
         ~1.500 ms  loaderul dispare (1000 fix + 500 fade)
         ~4.000 ms  apare aplicația (gărzile secvențiale din `onAuthenticated`)
       Între ele, ~2,5 s de pagină goală: `#welcomeScreen` e `hidden`, `#mainApp`
       e `hidden`, iar SINGURUL element nedescuns e `<footer class="legal-footer">`
       — el e FRATE cu `#mainContainer` (index.html), deci nu-l ascunde nimeni, iar
       `placeLegalFooter()` (nav.js) îl mută abia când `appVisible()` devine
       adevărat (cere `#mainApp` vizibil ȘI `state.currentUser`). De aici impresia
       că aplicația „se încarcă foarte greu".
       ACUM: loaderul se retrage din ecranele REALE (welcome / login / recovery /
       mainApp / hub) — și DOAR de acolo. Cele 1000 ms artificiale dispar de pe
       FIECARE pornire, inclusiv pe drumul rapid (fără sesiune → ecran de
       întâmpinare). Când pornirea întârzie, plasa de siguranță de mai jos NU
       ascunde loaderul, ci îi schimbă mesajul și oferă un buton de reîncărcare.
   ⚠ `hideLoader()` se cheamă OBLIGATORIU și înainte de orice modal BLOCANT
     afișat în timpul pornirii (poarta de consimțământ): `.modal` are z-index 1000,
     `#loader` are 9999 (style.css) — fără asta, utilizatorul ar rămâne blocat sub
     loader, cu `onAuthenticated` în așteptare la infinit.
   EN: the loader used to hide on a fixed 1s timer unrelated to app readiness,
       leaving a ~2.5s blank page where the only un-hidden element was the legal
       footer. It now hides only when a real screen appears, and the artificial 1s
       delay is gone from every startup. It must also be hidden before any blocking
       startup modal, since `.modal` sits below `#loader`.
   ========================================================================= */
let _loaderHidden = false;
let _loaderSlowTimer = null;
let _loaderStuckTimer = null;

/* Praguri (ms). 3500: peste durata normală măsurată (~4 s total), deci mesajul
   „durează mai mult" nu apare la o pornire obișnuită. 12000: pe `Slow 3G` o
   pornire perfect SĂNĂTOASĂ depășea 8 s — la 8 s butonul ar fi apărut degeaba,
   speriind utilizatorul într-un caz care se rezolva singur. */
const LOADER_SLOW_MS = 3500;
const LOADER_STUCK_MS = 12000;

function _clearLoaderTimers() {
    try { if (_loaderSlowTimer) { clearTimeout(_loaderSlowTimer); _loaderSlowTimer = null; } } catch (e) { /* noop */ }
    try { if (_loaderStuckTimer) { clearTimeout(_loaderStuckTimer); _loaderStuckTimer = null; } } catch (e) { /* noop */ }
}

/* Idempotentă: se cheamă din 5 funcții de ecran + plasa de siguranță; primul
   apel câștigă, restul sunt no-op (fără fade-uri suprapuse). */
function hideLoader() {
    if (_loaderHidden) return;
    _loaderHidden = true;
    _clearLoaderTimers();
    var el = document.getElementById('loader');
    if (!el) return;
    el.style.opacity = '0';
    setTimeout(function () { try { el.style.display = 'none'; } catch (e) { /* noop */ } }, 500);
}

/* Plasa de siguranță, pornită de `init()`. Două etaje, AMBELE non-distructive —
   loaderul rămâne pe ecran în ambele cazuri:
   1) la LOADER_SLOW_MS: „durează mai mult decât de obicei";
   2) la LOADER_STUCK_MS: mesaj mai explicit + buton de reîncărcare.
   ⛔ DE CE etajul 2 NU mai ascunde loaderul (corectat 25 aug. 2026): prima
      versiune chema `hideLoader()` la 8 s, ca „ieșire de siguranță". Testerul a
      confirmat pe `Slow 3G` că asta REPRODUCEA exact defectul reparat — pagina
      goală cu subsolul legal — fiindcă aplicația avea nevoie de mai mult de 8 s.
      Ieșirea corectă e un CONTROL pe care utilizatorul îl poate apăsa, nu
      dispariția singurului lucru care îi arată că se întâmplă ceva.
   EN: both tiers keep the loader visible; the 8s tier used to hide it, which
       reproduced the blank screen this fix removes (confirmed on Slow 3G). */
function startLoaderWatchdog() {
    if (_loaderHidden) return;
    try {
        _clearLoaderTimers();
        _bindLoaderReload();
        _bindLoaderOnline();
        if (_loaderIsOffline()) _loaderShowOffline();
        _loaderSlowTimer = setTimeout(function () {
            if (_loaderHidden || _loaderIsOffline()) return; /* offline: rămâne mesajul de offline */
            var o = document.getElementById('loaderOffline');
            if (o) o.classList.add('hidden');
            var s = document.getElementById('loaderSlow');
            if (s) s.classList.remove('hidden');
        }, LOADER_SLOW_MS);
        _loaderStuckTimer = setTimeout(function () {
            if (_loaderHidden) return;
            /* Fără internet nu e o pornire blocată: fără eroare falsă în Sentry. */
            if (_loaderIsOffline()) { _loaderShowOffline(); return; }
            /* Mesajul de la etajul 1 e ÎNLOCUIT, nu dublat: două texte suprapuse
               despre aceeași problemă ar arăta ca un defect. */
            var o = document.getElementById('loaderOffline');
            if (o) o.classList.add('hidden');
            var s = document.getElementById('loaderSlow');
            if (s) s.classList.add('hidden');
            var k = document.getElementById('loaderStuck');
            if (k) k.classList.remove('hidden');
            var b = document.getElementById('loaderReloadBtn');
            if (b) b.classList.remove('hidden');
            /* Ajunge în Sentry + `client_errors` (§46 #28c): dacă se întâmplă des
               pe conexiuni normale, înseamnă că un drum de pornire s-a blocat. */
            try { if (typeof window.logError === 'function') window.logError('loaderStuck', new Error('startup still running after ' + LOADER_STUCK_MS + 'ms')); } catch (e) { /* noop */ }
        }, LOADER_STUCK_MS);
    } catch (e) { try { if (typeof window.logError === 'function') window.logError('startLoaderWatchdog', e); } catch (e2) { /* noop */ } }
}

/* Delegare de evenimente pe PĂRINTE (golden standard — zero `onclick=` nou).
   Ascultătorul se pune O SINGURĂ dată pe `#loader` și supraviețuiește oricărei
   rescrieri a conținutului lui. */
let _loaderReloadBound = false;
function _bindLoaderReload() {
    if (_loaderReloadBound) return;
    var host = document.getElementById('loader');
    if (!host) return;
    _loaderReloadBound = true;
    host.addEventListener('click', function (ev) {
        var el = ev.target && ev.target.closest ? ev.target.closest('[data-action="reload-app"]') : null;
        if (!el || !host.contains(el)) return;
        ev.preventDefault();
        /* A doua apăsare nu pornește o a doua reîncărcare (rețea foarte lentă:
           `reload()` poate dura vizibil până să preia pagina). */
        if (el.disabled) return;
        el.disabled = true;
        try { window.location.reload(); } catch (e) { try { window.location.href = window.location.href; } catch (e2) { /* noop */ } }
    });
}

/* ★ oct. 2026 — FĂRĂ INTERNET LA PORNIRE.
   RO: `navigator.onLine === false` e un semnal de ÎNCREDERE (spre deosebire de `true`, care
       poate minți pe un Wi-Fi fără internet). Înainte, o pornire offline aștepta 12 s ca să
       spună „conexiunea pare foarte lentă” — fals — și trimitea în Sentry o eroare falsă
       `loaderStuck` (confirmat de tester pe desktop și Android, 5 oct. 2026). Acum mesajul
       spune adevărul imediat, iar la revenirea conexiunii aplicația repornește singură —
       DOAR cât timp loaderul e încă pe ecran (o aplicație pornită nu se reîncarcă niciodată
       de aici). Cu `onLine === true`, comportamentul e identic cu cel de dinainte.
   EN: when the device reports offline, say so at once (no false "slow connection", no false
       Sentry error) and restart by itself when the connection is back — only while loading. */
function _loaderIsOffline() {
    try { return navigator.onLine === false; } catch (e) { return false; }
}

function _loaderShowOffline() {
    if (_loaderHidden) return;
    var s = document.getElementById('loaderSlow');
    if (s) s.classList.add('hidden');
    var k = document.getElementById('loaderStuck');
    if (k) k.classList.add('hidden');
    var o = document.getElementById('loaderOffline');
    if (o) o.classList.remove('hidden');
    var b = document.getElementById('loaderReloadBtn');
    if (b) b.classList.remove('hidden');
}

let _loaderOnlineBound = false;
function _bindLoaderOnline() {
    if (_loaderOnlineBound) return;
    _loaderOnlineBound = true;
    window.addEventListener('offline', function () {
        try { _loaderShowOffline(); } catch (e) { /* noop */ }
    });
    window.addEventListener('online', function () {
        /* 1500 ms: evenimentul vine uneori înainte ca rețeaua să fie chiar utilizabilă.
           EN: the event can fire before the network is actually usable. */
        setTimeout(function () {
            if (_loaderHidden || _loaderIsOffline()) return;
            try { window.location.reload(); } catch (e) { /* noop */ }
        }, 1500);
    });
}

function loadState() {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) {
            const loaded = JSON.parse(saved);
            Object.keys(loaded).forEach(key => {
                if (key in state) {
                    if (typeof state[key] === 'object' && !Array.isArray(state[key])) {
                        state[key] = {...state[key], ...loaded[key]};
                    } else {
                        state[key] = loaded[key];
                    }
                }
            });
            
            // Migration checks
            if (!state.version || state.version < "3.0") {
                migrateData();
            }
        }
    } catch (error) {
        console.error('Error loading state:', error);
        showNotification(t('core.loadErrorDemo'), 'error');
        initDemoData();
    }
}

function migrateData() {
    if (!state.events) state.events = [];
    if (!state.backups) state.backups = [];
    if (!state.onlineUsers) state.onlineUsers = {};
    if (!state.notifications) state.notifications = [];
    if (!state.settings) {
        state.settings = {
            pointsPerWin: 3,
            pointsPerSecond: 2,
            pointsPerThird: 1,
            pointsPerParticipation: 0.5,
            chatNotifications: true,
            emailNotifications: false,
            theme: "dark",
            language: "ro"
        };
    }
    
    state.version = "3.0";
    saveState();
}

function initDemoData() {
    if (Object.keys(state.users).length === 0 && Object.keys(state.catalog).length === 0) {
        console.log('Initializing demo data...');
        
        // Demo users (DOAR pentru modul Demo local - fără parole în cod)
        state.users = {
            "admin@gbgsc.ro": {
                name: "Administrator",
                email: "admin@gbgsc.ro",
                isAdmin: true,
                role: "admin",
                points: 0,
                createdAt: new Date().toISOString(),
                lastLogin: new Date().toISOString(),
                verified: true
            },
            "alice@example.com": {
                name: "Alice",
                email: "alice@example.com",
                isAdmin: false,
                role: "member",
                points: 45.5,
                createdAt: new Date().toISOString(),
                lastLogin: new Date().toISOString(),
                verified: true
            }
        };
        
        // Demo members (Faza 2: id-uri sintetice stabile + membersById)
        state.members = {
            "Alice": {
                dbId: "demo-alice", name: "Alice", displayName: "Alice", role: "admin", userTag: "alice",
                score: 45.5, 
                gamesPlayed: 12, 
                hidden: false, 
                email: "alice@example.com",
                joinDate: "2024-01-15",
                preferredGames: ["Catan", "Azul"],
                skillLevel: 4
            },
            "Bob": {
                dbId: "demo-bob", name: "Bob", displayName: "Bob", role: "member", userTag: "bob",
                score: 38.0, 
                gamesPlayed: 10, 
                hidden: false, 
                email: null,
                joinDate: "2024-02-10",
                preferredGames: ["Gloomhaven", "Terraforming Mars"],
                skillLevel: 5
            },
            "Charlie": {
                dbId: "demo-charlie", name: "Charlie", displayName: "Charlie", role: "member", userTag: "charlie",
                score: 42.5, 
                gamesPlayed: 11, 
                hidden: false, 
                email: null,
                joinDate: "2024-01-20",
                preferredGames: ["Ticket to Ride", "Codenames"],
                skillLevel: 3
            },
            "Diana": {
                dbId: "demo-diana", name: "Diana", displayName: "Diana", role: "member", userTag: "diana",
                score: 35.0, 
                gamesPlayed: 9, 
                hidden: false, 
                email: null,
                joinDate: "2024-02-05",
                preferredGames: ["Azul", "7 Wonders"],
                skillLevel: 3
            }
        };
        state.membersById = {};
        state.profileNamesById = {};
        Object.keys(state.members).forEach(function (nm) {
            var m = state.members[nm];
            if (m && m.dbId) { state.membersById[m.dbId] = m; state.profileNamesById[m.dbId] = m.displayName || m.name || nm; }
        });
        
        // Demo catalog
        state.catalog = {
            "Catan": {
                categories: ["Eurogame", "Strategie"],
                players: "3-4",
                duration: 60,
                difficulty: 3,
                rating: 8.5,
                description: t('demo.descCatan'),
                bggId: "13",
                timesPlayed: 15,
                avgDuration: 75,
                lastPlayed: new Date().toISOString()
            },
            "Azul": {
                categories: ["Strategie", "Abstract"],
                players: "2-4",
                duration: 45,
                difficulty: 2,
                rating: 9.0,
                description: t('demo.descAzul'),
                bggId: "230802",
                timesPlayed: 12,
                avgDuration: 40,
                lastPlayed: new Date(Date.now() - 86400000).toISOString()
            },
            "Gloomhaven": {
                categories: ["Cooperativ", "RPG", "Legacy", "Strategie"],
                players: "1-4",
                duration: 120,
                difficulty: 5,
                rating: 9.2,
                description: t('demo.descGloomhaven'),
                bggId: "174430",
                timesPlayed: 8,
                avgDuration: 180,
                lastPlayed: new Date(Date.now() - 172800000).toISOString()
            },
            "Ticket to Ride": {
                categories: ["Eurogame", "Familie"],
                players: "2-5",
                duration: 60,
                difficulty: 2,
                rating: 7.8,
                description: t('demo.descTtr'),
                bggId: "9209",
                timesPlayed: 10,
                avgDuration: 55,
                lastPlayed: new Date(Date.now() - 259200000).toISOString()
            }
        };
        
        // Demo chat messages
        state.chatMessages = [
            {
                id: Date.now() - 3600000,
                sender: "Alice",
                senderEmail: "alice@example.com",
                text: t('demo.chat1'), _demoKey: 'demo.chat1',
                timestamp: new Date(Date.now() - 3600000).toISOString(),
                isAdmin: false
            },
            {
                id: Date.now() - 1800000,
                sender: "Bob",
                senderEmail: null,
                text: t('demo.chat2'), _demoKey: 'demo.chat2',
                timestamp: new Date(Date.now() - 1800000).toISOString(),
                isAdmin: false
            },
            {
                id: Date.now() - 900000,
                sender: "Administrator",
                senderEmail: "admin@gbgsc.ro",
                text: t('demo.chat3'), _demoKey: 'demo.chat3',
                timestamp: new Date(Date.now() - 900000).toISOString(),
                isAdmin: true
            }
        ];
        
        // Demo polls
        state.polls = [
            {
                id: "demo-poll-1",
                question: t('demo.pollQuestion'),
                options: [
                    { text: "Catan", votes: [{ name: "Alice", email: "alice@example.com" }, { name: "Bob", email: null }] },
                    { text: "Azul", votes: [{ name: "Charlie", email: null }] },
                    { text: "Ticket to Ride", votes: [{ name: "Diana", email: null }] }
                ],
                allowMultiple: false,
                showVoters: true,
                createdBy: "Alice",
                createdAt: new Date(Date.now() - 86400000).toISOString(),
                expiresAt: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
                active: true
            }
        ];
        
        // Demo events
        state.events = [
            {
                id: "demo-event-1",
                title: t('demo.eventTitle'),
                description: t('demo.eventDesc'),
                date: new Date(Date.now() + 86400000).toISOString(),
                type: "tournament",
                location: t('demo.eventLocation'),
                participants: ["Alice", "Bob", "Charlie", "Diana"],
                organizer: "Administrator"
            }
        ];
        
        // Initial regulation
        initRegulation();
        
        saveState();
    }
}

function setupEventListeners() {
    // Enter key for chat and forms
    document.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
            /* v9 8.1bis (H21): Enter din `#chatInput` NU se mai tratează aici. Pe telefon
               Enter adaugă un rând nou, iar ramura de aici ar fi trimis mesajul oricum.
               Tasta e tratată acum doar de chat-core.js (`TO_CHAT.composer`).
               EN: chat Enter is owned by chat-core.js; this branch would send on phones. */
            if (e.target.id === 'loginEmail' || e.target.id === 'loginPassword') {
                login();
            } else if (e.target.id === 'regName' || e.target.id === 'regEmail' || e.target.id === 'regPassword' || e.target.id === 'regPasswordConfirm') {
                register();
            } else if (e.target.id === 'resetEmail' || e.target.id === 'resetCode' || e.target.id === 'resetNewPassword') {
                if (document.getElementById('resetPasswordBtn') && !document.getElementById('resetPasswordBtn').classList.contains('hidden')) {
                    resetPassword();
                } else {
                    sendResetCode();
                }
            } else if (e.target.id === 'adminPassword') {
                loginAdmin();
            }
        }
    });
    
    // Escape key to close modals
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeAllModals();
        }
    });
    
    // Online status detection
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);
    
    // Beforeunload to save state
    window.addEventListener('beforeunload', () => {
        if (state.currentUser) {
            updateOnlineStatus(false);
            saveState();
        }
    });
}

/* ================= MODAL FUNCTIONS =================
   Ciclu de viață unificat (fix §1 „modale moarte la redeschidere"):
   - Modalele STATICE (definite în index.html, marcate cu data-static="1"):
     doar ASCUNSE (scoatem .active) — nodul persistă, openerii îl refolosesc.
   - Modalele EFEMERE (create dinamic + appendChild pe body — restul):
     ELIMINATE din DOM. Așa dispar și id-urile lor interne + spinnerele, deci la
     redeschidere getElementById nu mai prinde un nod-fantomă vechi (cauza-rădăcină).
   Cârlig extensibil (fără registru central): dacă un modal își pune propria
   curățare (ex. listeneri la nivel de document) pe modal.__dispose, o apelăm pe
   ea în loc de eliminarea brută. */
function _isStaticModal(modal) {
    return !!(modal && modal.dataset && modal.dataset.static === '1');
}
function _disposeModal(modal) {
    if (!modal || !modal.classList || !modal.classList.contains('modal')) return;
    if (_isStaticModal(modal)) { modal.classList.remove('active'); return; }
    if (typeof modal.__dispose === 'function') { try { modal.__dispose(); return; } catch (e) { logError('_disposeModal', e); } }
    if (modal.parentNode) modal.parentNode.removeChild(modal);
}
function closeModal(modalId) {
    _disposeModal(document.getElementById(modalId));
}
function closeAllModals() {
    /* TOATE modalele, nu doar .active: purjăm și eventualii orfani efemeri rămași
       dintr-o închidere anterioară (Escape / tap pe fundal), ca să nu se acumuleze. */
    document.querySelectorAll('.modal').forEach(_disposeModal);
}

/* ===== Documente legale (Termeni / Confidențialitate / Cookie-uri) ===== */
/* Istoric versiuni: cea mai recentă PRIMA. Pentru o actualizare viitoare:
   1) arhivează textul vechi într-o cheie i18n nouă (ex: 'legal.terms.body.2026a');
   2) actualizează 'legal.X.body' cu textul nou;
   3) adaugă în capul listei o intrare { date, labelKey, bodyKey } pentru noua versiune
      și pune bodyKey-ul arhivat pe intrarea veche. */
const LEGAL_HISTORY = {
    terms:   [{ date: '[DATA_INTRARII_IN_VIGOARE]', labelKey: 'legal.initialVersion', bodyKey: 'legal.terms.body' }],
    privacy: [{ date: '[DATA_INTRARII_IN_VIGOARE]', labelKey: 'legal.initialVersion', bodyKey: 'legal.privacy.body' }],
    cookies: [{ date: '[DATA_INTRARII_IN_VIGOARE]', labelKey: 'legal.initialVersion', bodyKey: 'legal.cookies.body' }]
};
let _currentLegalDoc = 'terms';
function _legalT(k) { return (typeof t === 'function') ? t(k) : k; }

function openLegal(doc) {
    const titles = { terms: 'footer.terms', privacy: 'footer.privacy', cookies: 'footer.cookies' };
    const key = titles[doc] ? doc : 'terms';
    _currentLegalDoc = key;
    const hist = LEGAL_HISTORY[key];
    const titleEl = document.getElementById('legalModalTitle');
    const dateEl = document.getElementById('legalModalDate');
    const bodyEl = document.getElementById('legalModalBody');
    const panel = document.getElementById('legalHistoryPanel');
    const infoBtn = document.getElementById('legalInfoBtn');
    if (titleEl) titleEl.textContent = _legalT(titles[key]);
    if (dateEl) dateEl.textContent = _legalT('legal.effective') + ': ' + hist[0].date;
    if (bodyEl) bodyEl.innerHTML = _legalT(hist[0].bodyKey);
    if (infoBtn) infoBtn.title = _legalT('legal.history');
    if (panel) { panel.classList.remove('open'); panel.innerHTML = ''; }
    const modal = document.getElementById('legalModal');
    if (modal) modal.classList.add('active');
}
/* alias compat pentru vechiul apel showTermsModal() */
function showTermsModal() { openLegal('terms'); }

/* ===== Notificare cookie-uri: informativă (doar esențiale), o dată per dispozitiv, 3s ===== */
function dismissCookieNotice() {
    var el = document.getElementById('cookieNotice');
    if (el) el.classList.remove('show');
    try { localStorage.setItem('to_cookie_notice_seen', '1'); } catch (e) { logError('dismissCookieNotice', e); }
}
function maybeShowCookieNotice() {
    var seen = false;
    try { seen = localStorage.getItem('to_cookie_notice_seen') === '1'; } catch (e) { logError('maybeShowCookieNotice', e); }
    if (seen) return;
    var el = document.getElementById('cookieNotice');
    if (!el) return;
    setTimeout(function () { el.classList.add('show'); }, 800);
    setTimeout(function () { dismissCookieNotice(); }, 3800); /* vizibil ~3 secunde */
}
window.addEventListener('load', maybeShowCookieNotice);

function toggleLegalHistory() {
    const panel = document.getElementById('legalHistoryPanel');
    if (!panel) return;
    if (panel.classList.contains('open')) { panel.classList.remove('open'); return; }
    renderLegalHistory(_currentLegalDoc);
    panel.classList.add('open');
}

function renderLegalHistory(doc) {
    const panel = document.getElementById('legalHistoryPanel');
    if (!panel) return;
    const hist = LEGAL_HISTORY[doc] || [];
    let html = '<div class="legal-history-title">' + _legalT('legal.history') + '</div>';
    hist.forEach(function (v, i) {
        const label = _legalT(v.labelKey);
        const current = (i === 0) ? ' <span class="legal-badge-current">(' + _legalT('legal.current') + ')</span>' : '';
        const action = (i === 0) ? '' : ' <a href="javascript:void(0)" onclick="viewLegalVersion(\'' + doc + '\',' + i + ')">' + _legalT('legal.viewThis') + '</a>';
        html += '<div class="legal-history-row"><span>' + v.date + ' — ' + label + current + '</span><span>' + action + '</span></div>';
    });
    if (hist.length <= 1) { html += '<div class="legal-history-hint">' + _legalT('legal.historyHint') + '</div>'; }
    panel.innerHTML = html;
}

function viewLegalVersion(doc, idx) {
    const hist = LEGAL_HISTORY[doc] || [];
    const v = hist[idx]; if (!v) return;
    const bodyEl = document.getElementById('legalModalBody');
    const dateEl = document.getElementById('legalModalDate');
    if (bodyEl) bodyEl.innerHTML = _legalT(v.bodyKey);
    if (dateEl) dateEl.textContent = _legalT('legal.effective') + ': ' + v.date;
}

/* ================= AUTHENTICATION ================= */
/* ===================== LIGHTBOX (vizualizare imagine full-screen) ===================== */
/* ===================== LIGHTBOX CU GALERIE (aug. 2026) =====================
   RO: `openLightbox` primea O SINGURĂ poză. Acum acceptă un al TREILEA parametru
       OPȚIONAL — elementul `<img>` apăsat — din care deduce galeria: frații lui
       `img[data-sp]` din același container.
   ⚠ DE CE elementul, și nu o listă serializată în `onclick`: apelul din istoric
     e un `onclick` inline, iar a scrie acolo un tablou de 15 căi ar fi însemnat
     escapare manuală pentru fiecare — exact tiparul fragil pe care l-am eliminat
     în altă parte. `this` e o referință, nu text: nimic de escapat.
   ⚠ CEI 9 APELANȚI EXISTENȚI (avatar club ×2, moderare ×4, anunțuri ×2, avatare
     profil ×2) NU se ating: fără al treilea parametru, comportamentul e IDENTIC
     cu cel de azi — o poză, fără navigare.
   ⚠ SEMNAREA nu are mecanism nou. Bucket-ul `session-photos` e privat, dar există
     deja `signOnePhoto` + observatorul global de la supabase-integration.js, iar
     rezultatele se păstrează în `signed` pe durata galeriei, deci fiecare poză se
     semnează O SINGURĂ dată. Vecinii se semnează în avans, ca glisarea să nu
     aștepte un dus-întors.
   EN: optional third arg (the clicked <img>) turns the lightbox into a gallery
       built from its `img[data-sp]` siblings; all 9 existing callers are
       unaffected. Signed URLs are cached and neighbours are prefetched. ── */
var _lbState = null;

/* Galeria se deduce din DOM: frații marcați cu `data-gal` ai elementului apăsat.
   ⚠ DE CE UN ATRIBUT PROPRIU ȘI NU `data-sp`: observatorul de semnare
     (supabase-integration.js, `flush()`) face `el.removeAttribute('data-sp')`
     imediat ce a înlocuit `src` cu adresa semnată. Adică exact atributul pe care
     m-aș fi bazat DISPARE înainte ca utilizatorul să apuce să apese — prima
     versiune a acestei funcții găsea zero frați și nu construia nicio galerie.
     `data-gal` păstrează calea nesemnată a pozei și nu e atins de nimeni.
   ⚠ Sub 2 poze nu e galerie — nu arătăm săgeți pentru o singură imagine.
   EN: uses its own `data-gal` attribute because the signing observer strips
       `data-sp` as soon as it swaps in the signed URL. */
function _lbBuildGallery(fromEl) {
    try {
        if (!fromEl || !fromEl.parentNode || !fromEl.getAttribute) return null;
        var nodes = fromEl.parentNode.querySelectorAll('img[data-gal]');
        if (!nodes || nodes.length < 2) return null;
        var list = [], shown = [], idx = 0, Z = window.TO_ZOOM;
        for (var i = 0; i < nodes.length; i++) {
            list.push(nodes[i].getAttribute('data-gal'));
            /* v9 8.5-B2: miniatura deja afișată în colaj (sau null) — o arătăm instant */
            shown.push(Z && Z.shown ? Z.shown(nodes[i]) : null);
            if (nodes[i] === fromEl) idx = i;
        }
        return { list: list, index: idx, shown: shown };
    } catch (e) { logError('_lbBuildGallery', e); return null; }
}

function _lbSign(i) {
    var st = _lbState;
    if (!st || i < 0 || i >= st.list.length) return Promise.resolve(null);
    var raw = st.list[i];
    if (st.signed[i]) return Promise.resolve(st.signed[i]);
    var needs = (String(raw).indexOf('://') === -1) || (String(raw).indexOf('/session-photos/') !== -1);
    if (!needs || typeof window.signOnePhoto !== 'function') { st.signed[i] = raw; return Promise.resolve(raw); }
    return window.signOnePhoto(raw).then(function (s) { st.signed[i] = s || raw; return st.signed[i]; });
}

/* Semnarea vecinilor, în avans: fără ea, fiecare glisare ar aștepta un
   dus-întors la server, iar o galerie care se blochează la fiecare pas e mai
   proastă decât una fără glisare. Doar ±1, nu toate cele 15. */
/* v9 8.5-B2: vecinii se și DESCARCĂ (originalele), nu doar se semnează — din 8.5-B
   colajul are doar miniaturi, deci altfel fiecare glisare aștepta descărcarea. Se
   cheamă după ce poza de pe ecran a venit (ea are prioritate). Un mesaj din chat are
   cel mult 4 poze ⇒ le luăm pe toate; galeriile mai mari (sesiuni, până la 12) ⇒ ±1,
   circular, ca navigarea. EN: download (not just sign) the neighbours' originals. */
function _lbPrefetch(i) {
    try {
        var st = _lbState, Z = window.TO_ZOOM;
        if (!st) return;
        var n = st.list.length, js = [];
        if (n <= 4) { for (var j = 0; j < n; j++) if (j !== i) js.push(j); }
        else js = [(i + 1) % n, (i - 1 + n) % n];
        js.forEach(function (k) {
            _lbSign(k).then(function (url) {
                if (_lbState === st && url && st.pre && Z && Z.preload) Z.preload(st.pre, k, url).catch(function () { /* la deschidere se reîncearcă */ });
            });
        });
    } catch (e) { logError('_lbPrefetch', e); }
}

function _lbGoto(delta) {
    var st = _lbState;
    if (!st) return;
    var n = st.list.length;
    var i = ((st.index + delta) % n + n) % n;   /* circular */
    st.index = i;
    var Z = window.TO_ZOOM, img = document.getElementById('lightboxImg');
    /* v9 8.5-B2: IMEDIAT, fără să așteptăm rețeaua: originalul deja descărcat, altfel
       miniatura vecinului, altfel poza veche estompată (înainte rămânea poza veche,
       neschimbată, până venea cea nouă ⇒ părea blocată). EN: instant feedback on swipe. */
    if (img && Z && Z.sharpen && st.pre) {
        var pre = st.pre[i], ph = st.shown && st.shown[i];
        if (pre && pre.ok) { img.src = pre.url; Z.unfit(img); }
        else if (ph) { img.src = ph.url; img.style.opacity = ''; Z.fitTo(img, ph.w, ph.h); }
        /* estompare DOAR dacă durează: poza veche vine din cache-ul browserului în
           câțiva ms, iar o estompare imediată ar clipi la fiecare glisare */
        else setTimeout(function () {
            var p = st.pre[i];
            if (_lbState === st && st.index === i && p && !p.ok) img.style.opacity = '0.4';
        }, 150);
    }
    try { if (Z) Z.reset(); } catch (e) { logError('_lbGoto.zoom', e); }   /* v9 8.1-z: poza nouă de la 1× */
    var cnt = document.getElementById('lightboxCount');
    if (cnt) cnt.textContent = (i + 1) + ' / ' + n;
    _lbSign(i).then(function (url) {
        if (_lbState !== st || st.index !== i) return;   /* s-a mai navigat între timp */
        var im = document.getElementById('lightboxImg');
        if (!im || !url) return;
        if (Z && Z.sharpen && st.pre) {
            Z.sharpen(im, url, st.pre, i, function () { return _lbState === st && st.index === i; })
                .then(function (ok) { if (ok) _lbPrefetch(i); });
            return;
        }
        im.src = url;   /* fără lightbox-zoom.js: ca înainte */
        _lbPrefetch(i);
    });
}

function openLightbox(src, reportCtx, fromEl) {
    if (!src) return;
    var Z = window.TO_ZOOM;
    var gal = _lbBuildGallery(fromEl);
    /* v9 8.5-B2: o singură poză care arată o miniatură = galerie de una (fără săgeți),
       ca să se deschidă și ea instant. Restul apelurilor cu o poză: neschimbate. */
    if (!gal && Z && Z.shown) { var ph1 = Z.shown(fromEl); if (ph1) gal = { list: [src], index: 0, shown: [ph1] }; }
    if (gal) {
        var st = { list: gal.list, index: gal.index, reportCtx: reportCtx || null, signed: {}, shown: gal.shown || [], pre: {} };
        var i0 = gal.index, ph = st.shown[i0];
        _lbState = st;
        /* 8.5-B2: miniatura e deja în telefon ⇒ galeria apare ACUM, originalul o înlocuiește când vine */
        if (ph && Z.sharpen) { _openLightboxWith(ph.url, reportCtx, gal.list[i0]); Z.fitTo(document.getElementById('lightboxImg'), ph.w, ph.h); }
        _lbSign(i0).then(function (url) {
            if (_lbState !== st) return;   /* închisă sau înlocuită între timp */
            if (ph && Z.sharpen) {
                var im = document.getElementById('lightboxImg');
                if (!im || !url || st.index !== i0) return;
                Z.sharpen(im, url, st.pre, i0, function () { return _lbState === st && st.index === i0; })
                    .then(function (ok) { if (ok) _lbPrefetch(i0); });
                return;
            }
            _openLightboxWith(url || src, reportCtx, gal.list[i0]);
            /* vecinii DUPĂ poza de pe ecran (ea are prioritate la descărcare) */
            var im0 = document.getElementById('lightboxImg');
            if (im0 && !(im0.complete && im0.naturalWidth)) im0.addEventListener('load', function () { _lbPrefetch(i0); }, { once: true });
            else _lbPrefetch(i0);
        });
        return;
    }
    _lbState = null;
    /* Bucket privat 'session-photos': dacă e un path/URL de poză, semnează-l întâi.
       (Path bare fără '://' SAU URL public vechi care conține /session-photos/.)
       origSrc = identitatea pozei (path) pentru report — NU URL-ul semnat. */
    var origSrc = src;
    var _needSign = (src.indexOf('://') === -1) || (src.indexOf('/session-photos/') !== -1);
    if (_needSign && typeof window.signOnePhoto === 'function') {
        window.signOnePhoto(src).then(function (signed) { _openLightboxWith(signed || src, reportCtx, origSrc); });
        return;
    }
    _openLightboxWith(src, reportCtx, origSrc);
}
function _openLightboxWith(src, reportCtx, origSrc) {
    if (!src) return;
    _lbRemoveOverlay();   /* NU `closeLightbox()` — ar șterge `_lbState` (vezi nota de acolo) */
    var ov = document.createElement('div');
    ov.id = 'lightboxOverlay';
    ov.style.cssText = 'position:fixed; inset:0; z-index:100000; background:rgba(0,0,0,0.9); display:flex; align-items:center; justify-content:center; padding:24px; cursor:zoom-out;';
    ov.onclick = function (e) { if (e.target === ov) closeLightbox(); };
    var img = document.createElement('img');
    img.id = 'lightboxImg';
    img.src = src;
    img.style.cssText = 'max-width:96vw; max-height:92vh; border-radius:10px; box-shadow:0 10px 40px rgba(0,0,0,0.6); object-fit:contain; cursor:default;';
    /* RO: Butoanele flotante ale lightbox-ului stau la 16px de marginea de sus —
           adică FIX sub crestătură / Dynamic Island pe iPhone, unde erau parțial
           acoperite și greu de atins. Aceeași corecție și pentru butonul rotund de
           sesiune rapidă, care cădea peste indicatorul de acasă.
       EN: safe-area offsets for the floating lightbox buttons and the quick FAB. */
    var close = document.createElement('button');
    close.innerHTML = '<i class="fas fa-times"></i>';
    close.setAttribute('aria-label', (typeof t === 'function') ? t('common.close') : 'Close');
    close.style.cssText = 'position:fixed; top:calc(16px + env(safe-area-inset-top, 0px)); right:calc(18px + env(safe-area-inset-right, 0px)); width:44px; height:44px; border-radius:50%; border:none; background:rgba(255,255,255,0.15); color:#fff; font-size:20px; cursor:pointer; display:flex; align-items:center; justify-content:center;';
    close.onclick = closeLightbox;
    ov.appendChild(img);
    ov.appendChild(close);
    if (reportCtx && reportCtx.type && typeof openReportModal === 'function') {
        var rep = document.createElement('button');
        rep.innerHTML = '<i class="fas fa-flag"></i>';
        rep.setAttribute('aria-label', (typeof t === 'function') ? t('report.action') : 'Report');
        rep.style.cssText = 'position:fixed; top:calc(16px + env(safe-area-inset-top, 0px)); right:calc(74px + env(safe-area-inset-right, 0px)); width:clamp(38px,11vw,44px); height:clamp(38px,11vw,44px); border-radius:50%; border:none; background:rgba(231,76,60,0.85); color:#fff; font-size:clamp(15px,4vw,18px); cursor:pointer; display:flex; align-items:center; justify-content:center;';
        rep.onclick = function (e) {
            e.stopPropagation();
            /* Pentru poze de sesiune ducem identitatea pozei specifice:
               target_id = "sesiuneId#path". Retro-compatibil: fără poză -> doar sesiuneId.
               ⚠ ÎN GALERIE, `origSrc` e poza cu care s-a DESCHIS lightbox-ul, nu cea
                 vizibilă acum. Fără recitirea de mai jos, cine glisează până la a
                 șaptea poză și apasă „Raportează" ar raporta PRIMA poză — adică
                 exact tipul de greșeală pe care nimeni n-o observă la testare, dar
                 care produce moderare pe conținut nevinovat.
               EN: in a gallery the report must target the photo currently shown,
                   not the one the lightbox was opened with. */
            var _cur = (_lbState && _lbState.list) ? _lbState.list[_lbState.index] : origSrc;
            var tid = reportCtx.id;
            if (reportCtx.type === 'photo' && _cur) {
                var pp = (typeof window._spPath === 'function') ? window._spPath(_cur) : _cur;
                if (pp) tid = String(reportCtx.id) + '#' + pp;
            }
            openReportModal(reportCtx.type, tid, { clubId: reportCtx.clubId });
        };
        ov.appendChild(rep);
    }
    if (_lbState && _lbState.list && _lbState.list.length > 1) _lbAddGalleryChrome(ov);
    document.body.appendChild(ov);
    document.addEventListener('keydown', _lightboxEsc);
    /* v9 8.1-z: mărirea pozei (lightbox-zoom.js) — prindere cu două degete, dublă atingere,
       rotița; mărită, glisarea și închiderea prin atingere sunt oprite acolo.
       EN: image zoom lives in lightbox-zoom.js. */
    try { if (window.TO_ZOOM) window.TO_ZOOM.attach(ov, img); } catch (e) { logError('_openLightboxWith.zoom', e); }
}

/* Săgeți, indicator „3 / 7" și glisare. Se adaugă DOAR când există galerie. */
function _lbAddGalleryChrome(ov) {
    var T = (typeof t === 'function') ? t : function (k, f) { return f || k; };
    var n = _lbState.list.length;

    function navBtn(dir, icon, side, labelKey) {
        var b = document.createElement('button');
        b.innerHTML = '<i class="fas fa-' + icon + '"></i>';
        b.setAttribute('aria-label', T(labelKey));
        /* `env(safe-area-inset-*)` pe laterale, ca butoanele să nu cadă sub
           marginile curbate / crestătură — aceeași grijă ca la butonul de închidere. */
        b.style.cssText = 'position:fixed; top:50%; transform:translateY(-50%); ' + side +
            ':calc(10px + env(safe-area-inset-' + (side === 'left' ? 'left' : 'right') + ', 0px)); ' +
            'width:48px; height:48px; border-radius:50%; border:none; background:rgba(255,255,255,0.15); ' +
            'color:#fff; font-size:20px; cursor:pointer; display:flex; align-items:center; justify-content:center;';
        b.onclick = function (e) { e.stopPropagation(); _lbGoto(dir); };
        return b;
    }
    ov.appendChild(navBtn(-1, 'chevron-left', 'left', 'lb.prev'));
    ov.appendChild(navBtn(1, 'chevron-right', 'right', 'lb.next'));

    var cnt = document.createElement('div');
    cnt.id = 'lightboxCount';
    cnt.setAttribute('aria-live', 'polite');
    cnt.style.cssText = 'position:fixed; bottom:calc(18px + env(safe-area-inset-bottom, 0px)); left:50%; transform:translateX(-50%); ' +
        'background:rgba(0,0,0,0.55); color:#fff; padding:6px 14px; border-radius:999px; font-size:0.9em; letter-spacing:.5px;';
    cnt.textContent = (_lbState.index + 1) + ' / ' + n;
    ov.appendChild(cnt);

    /* GLISARE. ⚠ Nu punem `touch-action: none` pe imagine: ar dezactiva și
       mărirea cu două degete, utilă tocmai la poze. În schimb reacționăm doar la
       UN singur deget și doar când mișcarea ORIZONTALĂ o domină clar pe cea
       verticală — astfel derularea paginii de dedesubt și pinch-zoom rămân
       nestingherite.
       EN: single-finger, horizontal-dominant swipes only, so pinch-zoom and
           vertical scrolling keep working. */
    var x0 = 0, y0 = 0, tracking = false, decided = false, horiz = false;
    ov.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) { tracking = false; return; }
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
        tracking = true; decided = false; horiz = false;
    }, { passive: true });
    ov.addEventListener('touchmove', function (e) {
        if (!tracking || !e.touches || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
        if (!decided && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
            decided = true;
            horiz = Math.abs(dx) > Math.abs(dy) * 1.5;
        }
        /* `preventDefault` DOAR pe glisare orizontală recunoscută. */
        if (decided && horiz && e.cancelable) e.preventDefault();
    }, { passive: false });
    ov.addEventListener('touchend', function (e) {
        if (!tracking || !decided || !horiz) { tracking = false; return; }
        tracking = false;
        var t0 = (e.changedTouches && e.changedTouches[0]);
        if (!t0) return;
        var dx = t0.clientX - x0;
        /* 50 px: sub prag e o atingere, nu o glisare — altfel închiderea prin
           atingere ar sări din greșeală la poza următoare. */
        if (Math.abs(dx) < 50) return;
        _lbGoto(dx < 0 ? 1 : -1);
    }, { passive: true });
}

function _lightboxEsc(e) {
    if (e.key === 'Escape') { closeLightbox(); return; }
    if (!_lbState || !_lbState.list || _lbState.list.length < 2) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); _lbGoto(-1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); _lbGoto(1); }
}

function _lbRemoveOverlay() {
    try { if (window.TO_ZOOM) window.TO_ZOOM.detach(); } catch (e) { logError('_lbRemoveOverlay.zoom', e); }   /* v9 8.1-z */
    var ov = document.getElementById('lightboxOverlay');
    if (ov) ov.remove();
    document.removeEventListener('keydown', _lightboxEsc);
}

/* ⚠ `closeLightbox` resetează ȘI starea galeriei, dar `_openLightboxWith` face
   curățenie pe prima linie ÎNAINTE de a randa. Dacă ar chema `closeLightbox`,
   ar șterge `_lbState` tocmai setat de `openLightbox` => verificarea „există
   galerie?" ar fi mereu falsă și săgețile n-ar apărea NICIODATĂ. (Exact defectul
   raportat de tester.) De aceea curățenia internă folosește `_lbRemoveOverlay`,
   iar resetarea stării rămâne doar pe închiderea REALĂ, cerută de utilizator.
   EN: the internal cleanup must not wipe the gallery state that was just set. */
function closeLightbox() {
    _lbRemoveOverlay();
    _lbState = null;
}

/* ===================== TASTATURA PE ECRAN — MODUL GLOBAL ====================
   RO: Pe telefon, deschiderea tastaturii schimbă cât din pagină se mai vede, dar
       CSS-ul singur NU poate afla asta. `dvh` reflectă viewportul de ASPECT, pe
       care browserul îl redimensionează doar uneori; nu spune cât ocupă tastatura
       și nici când apare sau dispare. `:has(:focus)` e legat de un câmp anume —
       de aceea o regulă scrisă pentru `#chatInput` nu ajuta la niciun alt câmp
       din aplicație.
       `visualViewport` e singurul mecanism care raportează spațiul REAL rămas.
       Aici îl citim o singură dată, central, și publicăm rezultatul ca:
         · `--app-vh`    înălțimea chiar vizibilă (px)
         · `--kb-height` cât ocupă tastatura (px, 0 când e închisă)
         · `body.kb-open` marcaj pentru CSS
       Orice ecran care are nevoie folosește marcajul; nu se mai scriu reguli
       legate de câmpuri individuale.

   ⚠ PRAGUL de 120px: `visualViewport` se micșorează și când apar barele
     browserului la derulare (câteva zeci de px). Sub prag NU e tastatură, iar
     ascunderea barei de jos la fiecare derulare ar fi enervantă.
   ⚠ `visualViewport` NU e uniform între platforme: pe iOS raportează altfel
     decât pe Android, iar unele tastaturi terțe raportează cu întârziere. De
     aceea nu ne bazăm pe valori exacte, ci doar pe „deschisă / închisă" plus o
     înălțime folosită ca limită superioară.
   ⚠ Fără `visualViewport` (browsere vechi) modulul nu face NIMIC: `--app-vh`
     rămâne nesetat, iar CSS-ul cade pe `dvh`/`vh`, adică pe comportamentul de
     azi. Degradare curată.
   EN: single global source of truth for on-screen keyboard state, published as
       CSS variables plus a body class; CSS alone cannot detect the keyboard. */
const KB_MIN_PX = 120;
/* Cea mai mare înălțime văzută FĂRĂ tastatură. Se resetează la rotire. */
let _kbMaxH = 0;

function _kbApply() {
    try {
        const vv = window.visualViewport;
        if (!vv) return;
        const h = Math.round(vv.height);
        /* ⚠ NU folosim `innerHeight - vv.height`: cu
           `interactive-widget=resizes-content` (index.html) viewportul de ASPECT
           se micșorează ODATĂ cu cel vizual, deci diferența e mereu 0 și
           tastatura nu era detectată NICIODATĂ — cauza pentru care bara de jos și
           butonul „+" rămâneau peste tot.
           Comparăm în schimb cu cea mai mare înălțime văzută până acum. */
        if (h > _kbMaxH) _kbMaxH = h;
        const kb = Math.max(0, _kbMaxH - h);
        const open = kb >= KB_MIN_PX;

        const st = document.documentElement.style;
        st.setProperty('--app-vh', h + 'px');
        st.setProperty('--kb-height', (open ? kb : 0) + 'px');
        /* ⚠ iOS Safari NU suportă `interactive-widget`: la deschiderea tastaturii
           viewportul de ASPECT rămâne neschimbat, iar browserul DERULEAZĂ
           viewportul VIZUAL în interiorul lui (`offsetTop` > 0). Un strat
           `position: fixed; top: 0` se ancorează de viewportul de ASPECT, deci
           ajunge DEASUPRA zonei vizibile — exact ce se vedea în chatul pe ecran
           complet: antetul tăiat sus și o zonă goală jos. Publicăm decalajul ca
           `--vv-top`, iar stratul se ancorează de el (style.css).
           Pe Android `offsetTop` e 0 ⇒ comportament neschimbat.
           EN: iOS scrolls the visual viewport instead of resizing the layout one;
               fixed overlays must be offset by `visualViewport.offsetTop`. */
        st.setProperty('--vv-top', Math.max(0, Math.round(vv.offsetTop || 0)) + 'px');
        document.body.classList.toggle('kb-open', open);

        /* Măsurarea chatului se face separat, în DOUĂ treceri (vezi `_kbChatAvail`). */
        _kbChatAvail();
        if (!_kbAvailRaf) {
            _kbAvailRaf = requestAnimationFrame(function () { _kbAvailRaf = 0; _kbChatAvail(); });
        }
    } catch (e) { logError('_kbApply', e); }
}

/* Spațiul disponibil pentru chatul din tab (NU pentru cel pe ecran complet, care
   se dimensionează direct din `--app-vh`).
   ⚠ NU se calculează din „înălțime minus un număr inventat": deasupra chatului
     există un antet, iar sub el rămân paddinguri de card/container care diferă de
     la ecran la ecran. Măsurăm CÂT SPAȚIU RĂMÂNE sub container (`slack`) și îl
     adăugăm la înălțimea lui curentă — corecția e exactă și se auto-repară la
     fiecare eveniment, indiferent ce mai există dedesubt.
   ⚠ `getBoundingClientRect()` e în coordonate de ASPECT, iar `vv.height` e a
     viewportului VIZUAL. Pe iOS cele două sunt decalate cu `vv.offsetTop`, de
     aceea marginea de jos vizibilă e `offsetTop + height`, nu `height`.
   ⚠ Două treceri: prima rulează în aceeași cadră în care tocmai s-a pus
     `body.kb-open`, deci pornește de la înălțimea VECHE; a doua (rAF) confirmă
     rezultatul. Converge într-un singur pas, nu oscilează.
   EN: measures the leftover space below the chat container and folds it into the
       container height; self-correcting and iOS-offset aware. */
let _kbAvailRaf = 0;
let _kbAvailKey = '';
let _kbAvailPass = 0;
function _kbChatAvail() {
    try {
        const vv = window.visualViewport;
        if (!vv) return;
        if (!document.body.classList.contains('kb-open')) { _kbAvailPass = 0; _kbAvailKey = ''; return; }
        if (document.querySelector('#chatCard.chat-fullscreen')) return;
        const cont = document.querySelector('#tab-chat.active .chat-container');
        if (!cont) return;

        /* ⚠ BUCLĂ DE REACȚIE PE iOS — motivul acestei gărzi.
           Pe Android viewportul de ASPECT se micșorează odată cu tastatura, deci
           `rect.top` stă pe loc și corecția se așază din prima. Pe iOS aspectul
           rămâne la înălțimea plină: creșterea containerului face pagina mai
           înaltă, Safari derulează ca să vadă câmpul, `rect.top` se mută în sus,
           spațiul „liber dedesubt" pare din nou mare — și containerul crește la
           nesfârșit. Exact asta se vedea: fereastra de chat întinsă mult sub
           ecran, bara de scriere invizibilă și derulare fără capăt.
           Două opriri, ambele necesare:
             1. PLAFON — containerul nu are cum să fie util mai înalt decât zona
                vizibilă; peste atât, orice creștere e doar buclă.
             2. LIMITĂ DE TRECERI — cel mult șase măsurători per înălțime de
                tastatură. Pe Android convergența cere două; pe iOS geometria se
                mai mișcă între treceri, iar o limită de două o oprea ÎNAINTE de
                convergență — vizibil măsurat: baza containerului rămânea la 495
                cu zona vizibilă la 491, deci corecția finală de 4px nu mai apuca
                să fie aplicată. Șase treceri lasă loc de așezare, iar plafonul de
                mai sus rămâne oprirea dură împotriva buclei.
           ⚠ Cheia include înălțimea vizibilă ⇒ rotirea sau altă tastatură
             recalculează; închiderea tastaturii resetează contorul, ca redeschiderea
             să măsoare din nou.
           EN: iOS keeps the layout viewport at full height, so growing the chat
               scrolls the page and re-inflates the measurement — capped by the
               visible height and limited to six passes per keyboard height. */
        const h = Math.round(vv.height);
        const key = h + 'x' + Math.round(window.innerWidth || 0);
        if (key !== _kbAvailKey) { _kbAvailKey = key; _kbAvailPass = 0; }
        if (_kbAvailPass >= 6) return;

        const r = cont.getBoundingClientRect();
        if (!r.height) return;
        const vvBottom = Math.round((vv.offsetTop || 0) + vv.height);
        const slack = vvBottom - r.bottom;                       /* liber dedesubt; negativ = iese din ecran */
        _kbAvailPass++;
        if (Math.abs(slack) < 2) return;                          /* deja lipit — nu mai atingem nimic */
        const target = Math.min(h - 8, Math.max(160, Math.round(r.height + slack - 2)));
        document.documentElement.style.setProperty('--chat-avail', target + 'px');
    } catch (e) { logError('_kbChatAvail', e); }
}

/* Aducerea câmpului activ în vizor. Fără asta, în chatul pe ecran complet
   derulat în sus, apăsarea pe câmp lăsa tastatura peste el — inaccesibil.
   ⚠ Întârzierea: tastatura se animă, iar `visualViewport` raportează înălțimea
     finală abia după. O derulare imediată ar folosi dimensiunile vechi. */
let _kbScrollTimer = null;
function _kbScrollFocusedIntoView() {
    try {
        const el = document.activeElement;
        if (!el || !/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName || '')) return;
        if (el.type === 'file' || el.type === 'hidden') return;
        /* ⚠ Zonele de scriere sunt DEJA lipite de marginea de jos a containerului
           lor (flex), iar chatul pe ecran complet e un strat `position: fixed`
           ancorat de `--vv-top`. Pentru ele `scrollIntoView` nu are ce câștiga, în
           schimb derulează DOCUMENTUL de dedesubt — pe iOS exact asta arunca
           chatul în sus la atingerea barei de scriere, fiindcă Safari mișcă
           viewportul VIZUAL, nu pe cel de aspect.
           ⚠ Restrâns intenționat la aceste două cazuri: în modaluri și în
             formularul de sesiune aducerea câmpului în vizor rămâne utilă.
           EN: composer fields are already pinned to the visible bottom; scrolling
               the document underneath them is what pushed the iOS chat off-screen. */
        try { if (el.closest && el.closest('#chatCard.chat-fullscreen, .chat-input-area')) return; } catch (e2) { /* noop */ }
        if (_kbScrollTimer) clearTimeout(_kbScrollTimer);
        _kbScrollTimer = setTimeout(function () {
            try { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { /* noop */ }
        }, 220);
    } catch (e) { logError('_kbScrollFocusedIntoView', e); }
}

function initKeyboardModule() {
    try {
        const vv = window.visualViewport;
        if (!vv) return;   /* browser vechi -> comportamentul de azi */
        _kbApply();
        vv.addEventListener('resize', _kbApply);
        vv.addEventListener('scroll', _kbApply);
        window.addEventListener('orientationchange', function () {
            _kbMaxH = 0;   /* altfel maximul din portret ar face landscape-ul să pară „cu tastatură" */
            setTimeout(_kbApply, 250);
        });
        window.addEventListener('resize', _kbApply);
        /* `focusin` prinde ORICE câmp din aplicație, inclusiv cele create dinamic
           (modaluri, calculatorul de sesiune) — de aceea pe document, nu pe
           elemente individuale. */
        document.addEventListener('focusin', function () {
            _kbScrollFocusedIntoView();
            /* ⚠ Pe iOS `visualViewport` raportează decalajul final abia după
               animația tastaturii; fără această recitire, `--vv-top` rămâne 0 la
               primul focus și stratul fix pornește deplasat. */
            setTimeout(_kbApply, 320);
        });
        document.addEventListener('focusout', function () { setTimeout(_kbApply, 320); });
    } catch (e) { logError('initKeyboardModule', e); }
}
try { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initKeyboardModule); else initKeyboardModule(); } catch (e) { /* noop */ }

/* Show/Hide parolă (iconiță ochi) — login + sign up. */
/* Escape minimal pentru textul din modale. */
function _cmEsc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

/* Modal de confirmare unificat, în temă și traductibil. Întoarce o Promisiune<boolean>.
   Înlocuiește confirm() nativ. opts: { danger, title, confirmText, cancelText }. */
function confirmModal(message, opts) {
    opts = opts || {};
    return new Promise(function (resolve) {
        var T = (typeof t === 'function') ? t : function (k, f) { return f || k; };
        var prev = (typeof document !== 'undefined') ? document.activeElement : null;
        var danger = !!opts.danger;
        var title = opts.title || T('cm.title', 'Confirmare');
        var okTxt = opts.confirmText || T('cm.confirm', 'Confirmă');
        var cancelTxt = opts.cancelText || T('cm.cancel', 'Anulează');
        var msgHtml = _cmEsc(message).replace(/\n/g, '<br>');
        var ov = document.createElement('div');
        ov.className = 'modal active';
        ov.style.zIndex = '2147483600';
        if (ov.dataset) ov.dataset.dynamic = '1';
        ov.setAttribute('role', 'dialog');
        ov.setAttribute('aria-modal', 'true');
        ov.innerHTML =
            '<div class="modal-content" style="max-width:440px; width:440px; padding:26px;">'
            /* ⚠ 9.5: `hideIcon` — iconița din stânga plus spațiul ei mâncau vreo 50 px din
               lățime. Într-o întrebare de tip „ești sigur?" merită, fiindcă atrage atenția;
               într-un text explicativ lung doar îngustează rândurile și forțează derularea.
               EN: optional left icon; dropping it widens the text column. */
            + '<div style="display:flex; gap:' + (opts.hideIcon ? '0' : '14px') + '; align-items:flex-start;">'
            +   (opts.hideIcon ? '' : '<div style="font-size:1.7em; flex:none; line-height:1; color:' + (danger ? 'var(--danger,#ef4444)' : 'var(--accent-primary,#ff6b35)') + ';"><i class="fas fa-' + (danger ? 'triangle-exclamation' : 'circle-question') + '"></i></div>')
            +   '<div style="flex:1; min-width:0;">'
            +     '<h3 style="margin:0 0 8px; font-size:1.15em;">' + _cmEsc(title) + '</h3>'
            +     '<div style="color:var(--text-secondary); line-height:1.5; font-size:0.95em;">' + msgHtml + '</div>'
            +   '</div>'
            + '</div>'
            + '<div class="btn-group" style="display:flex; justify-content:flex-end; gap:10px; margin-top:22px;">'
            /* ⚠ 9.5: `hideCancel` — dialog pur informativ, cu UN singur buton. Fără el, o
               fereastră de tip „ce înseamnă asta?" ar fi avut și „Anulează", ceea ce nu
               are niciun sens acolo. Restul comportamentului e neschimbat: Escape și
               clicul în afară întorc tot `false`.
               EN: single-button informational variant; everything else unchanged. */
            +   (opts.hideCancel ? '' : '<button type="button" class="btn btn-secondary" data-cm="0">' + _cmEsc(cancelTxt) + '</button>')
            +   '<button type="button" class="btn ' + (danger ? 'btn-danger' : '') + '" data-cm="1">' + _cmEsc(okTxt) + '</button>'
            + '</div>'
            + '</div>';
        function cleanup(val) {
            document.removeEventListener('keydown', onKey, true);
            if (ov.parentNode) ov.parentNode.removeChild(ov);
            try { if (prev && prev.focus) prev.focus(); } catch (e) { logError('cleanup', e); }
            resolve(val);
        }
        function onKey(e) {
            if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); cleanup(false); }
            else if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); cleanup(true); }
        }
        ov.addEventListener('click', function (e) {
            if (e.target === ov) { cleanup(false); return; }
            var b = e.target.closest ? e.target.closest('[data-cm]') : null;
            if (b) cleanup(b.getAttribute('data-cm') === '1');
        });
        /* ⚠ Cârlig de închidere forțată. `_disposeModal` îl cheamă dacă există; fără el, un
           `closeAllModals()` venit din altă parte ștergea overlay-ul din DOM FĂRĂ să rezolve
           promisiunea. Cine scrisese `if (!await confirmModal(...)) return;` rămânea oprit
           acolo pentru totdeauna — fără eroare, fără urmă în consolă, doar „am apăsat și nu
           s-a întâmplat nimic".
           Răspunsul e `false`, adică „anulează": la orice închidere pe care utilizatorul nu a
           cerut-o explicit, NU presupunem că a confirmat. Multe dintre cele 55 de locuri care
           așteaptă acest dialog sunt ștergeri.
           ⚠ Nu am găsit azi o cale activă care să declanșeze asta — toate apelurile de
           `closeAllModals`/`closeAnyModal` rulează înainte sau după, nu în timpul dialogului.
           Cârligul e pus pentru ziua în care cineva scrie un flux nou în altă ordine.
           EN: forced-close hook; without it the promise never settled and the caller hung
           silently. Resolves false — never assume confirmation the user did not give. */
        ov.__dispose = function () { cleanup(false); };
        document.addEventListener('keydown', onKey, true);
        document.body.appendChild(ov);
        try { var fb = ov.querySelector(danger ? '[data-cm="0"]' : '[data-cm="1"]'); if (fb) fb.focus(); } catch (e) { logError('onKey', e); }
    });
}
window.confirmModal = confirmModal;

/* Dialog cu TREI optiuni, pentru iesirea dintr-un formular cu modificari nesalvate.
   Intoarce o Promisiune<'save'|'discard'|'stay'>.
   ------------------------------------------------------------------------------
   RO: DE CE o functie NOUA si nu o extindere a lui `confirmModal`: aceea are zeci de
   apelanti care se bazeaza pe raspuns boolean; orice schimbare acolo i-ar atinge pe toti.
   Aici raspunsul e un SIR, tocmai ca „am iesit fara sa salvez" sa nu poata fi confundat
   cu „m-am razgandit" — la `confirmModal`, Escape, clicul pe fundal si butonul Anuleaza
   dau toate `false`, deci distinctia e imposibila.

   ⚠ Alegeri deliberate, nu implicite:
   • Escape, clic pe fundal si inchiderea forsata raspund toate 'stay' — varianta care NU
     pierde munca utilizatorului. Ambiguitatea se rezolva mereu in favoarea pastrarii.
   • NU legam Enter global (cum face `confirmModal`). Cu trei butoane, un Enter fortat ar
     apasa altceva decat butonul pe care utilizatorul si-a pus focusul. Lasam activarea
     nativa a butonului focusat; la deschidere focusam „Salveaza", actiunea care nu distruge.
   • Punem `__dispose` pe overlay fiindca `_disposeModal` (mai sus) il cheama daca exista:
     asa, un `closeAllModals()` venit din alta parte REZOLVA promisiunea cu 'stay' in loc
     sa o lase agatata pentru totdeauna, cu navigarea blocata.
   opts: { title, saveText, discardText, stayText }
   EN: three-way unsaved-changes dialog returning 'save' | 'discard' | 'stay'. Every
   ambiguous exit resolves to 'stay' so work is never lost silently. */
function confirmModal3(message, opts) {
    opts = opts || {};
    return new Promise(function (resolve) {
        var T = (typeof t === 'function') ? t : function (k, f) { return f || k; };
        var prev = (typeof document !== 'undefined') ? document.activeElement : null;
        var title = opts.title || T('cm3.title', 'Modificări nesalvate');
        var msg = message || T('cm3.message', 'Ai modificări nesalvate. Ce vrei să faci?');
        var saveTxt = opts.saveText || T('cm3.save', 'Salvează și ieși');
        var discardTxt = opts.discardText || T('cm3.discard', 'Ieși fără să salvezi');
        var stayTxt = opts.stayText || T('cm3.stay', 'Rămâi aici');
        var msgHtml = _cmEsc(msg).replace(/\n/g, '<br>');
        var done = false;
        var ov = document.createElement('div');
        ov.className = 'modal active';
        ov.style.zIndex = '2147483600';
        if (ov.dataset) ov.dataset.dynamic = '1';
        ov.setAttribute('role', 'dialog');
        ov.setAttribute('aria-modal', 'true');
        ov.innerHTML =
            '<div class="modal-content" style="max-width:380px; width:100%; padding:22px;">'
            + '<div style="display:flex; gap:14px; align-items:flex-start;">'
            +   '<div style="font-size:1.7em; flex:none; line-height:1; color:var(--accent-primary,#ff6b35);"><i class="fas fa-triangle-exclamation"></i></div>'
            +   '<div style="flex:1; min-width:0;">'
            +     '<h3 style="margin:0 0 8px; font-size:1.15em;">' + _cmEsc(title) + '</h3>'
            +     '<div style="color:var(--text-secondary); line-height:1.5; font-size:0.95em;">' + msgHtml + '</div>'
            +   '</div>'
            + '</div>'
            /* Butoanele stau pe VERTICALA, fiecare pe toata latimea.
               ⚠ Prima varianta le punea pe un rand, cu `flex-wrap`: la trei etichete,
               al treilea buton pica singur pe randul doi si arata rupt. Pe orizontala,
               orice combinatie de etichete in doua limbi poate depasi latimea pe un
               telefon ingust si reproduce exact acel orfan. Verticala nu se poate strica
               la nicio latime si in nicio limba.
               Ordinea urmeaza greutatea actiunii: intai cea principala, apoi cea neutra,
               iar cea DISTRUCTIVA ultima si distantata, ca sa fie cel mai greu de atins
               din greseala. EN: buttons stack vertically; destructive last and separated. */
            + '<div class="btn-group" style="display:flex; flex-direction:column; gap:8px; margin-top:20px;">'
            +   '<button type="button" class="btn" data-cm3="save" style="width:100%;">' + _cmEsc(saveTxt) + '</button>'
            +   '<button type="button" class="btn btn-secondary" data-cm3="stay" style="width:100%;">' + _cmEsc(stayTxt) + '</button>'
            +   '<button type="button" class="btn btn-danger" data-cm3="discard" style="width:100%; margin-top:6px;">' + _cmEsc(discardTxt) + '</button>'
            + '</div>'
            + '</div>';
        function cleanup(val) {
            if (done) return;                       /* o singura rezolvare, orice s-ar intampla */
            done = true;
            document.removeEventListener('keydown', onKey, true);
            if (ov.parentNode) ov.parentNode.removeChild(ov);
            try { if (prev && prev.focus) prev.focus(); } catch (e) { logError('confirmModal3.cleanup', e); }
            resolve(val);
        }
        function onKey(e) {
            /* Oprim propagarea ca ascultatorul global de Escape (`closeAllModals`) sa nu
               stearga dialogul pe la spate, fara raspuns. */
            if (e.key === 'Escape') {
                e.preventDefault(); e.stopPropagation();
                if (e.stopImmediatePropagation) e.stopImmediatePropagation();
                cleanup('stay');
            }
        }
        ov.addEventListener('click', function (e) {
            if (e.target === ov) { cleanup('stay'); return; }
            var b = e.target.closest ? e.target.closest('[data-cm3]') : null;
            if (b) cleanup(b.getAttribute('data-cm3'));
        });
        ov.__dispose = function () { cleanup('stay'); };
        document.addEventListener('keydown', onKey, true);
        document.body.appendChild(ov);
        try { var fb = ov.querySelector('[data-cm3="save"]'); if (fb) fb.focus(); } catch (e) { logError('confirmModal3.focus', e); }
    });
}
window.confirmModal3 = confirmModal3;

/* Modal de input unificat, în temă și traductibil. Întoarce o Promisiune<string|null>
   (string-ul introdus la OK, null la anulare). Înlocuiește prompt() nativ.
   opts: { title, placeholder, confirmText, cancelText, password }. */
function promptModal(message, defaultValue, opts) {
    opts = opts || {};
    return new Promise(function (resolve) {
        var T = (typeof t === 'function') ? t : function (k, f) { return f || k; };
        var prev = (typeof document !== 'undefined') ? document.activeElement : null;
        var title = opts.title || T('cm.input', 'Introdu o valoare');
        var okTxt = opts.confirmText || T('cm.ok', 'OK');
        var cancelTxt = opts.cancelText || T('cm.cancel', 'Anulează');
        var msgHtml = message ? _cmEsc(message).replace(/\n/g, '<br>') : '';
        var ov = document.createElement('div');
        ov.className = 'modal active';
        ov.style.zIndex = '2147483600';
        if (ov.dataset) ov.dataset.dynamic = '1';
        ov.setAttribute('role', 'dialog');
        ov.setAttribute('aria-modal', 'true');
        ov.innerHTML =
            '<div class="modal-content" style="max-width:440px; width:440px; padding:26px;">'
            + '<h3 style="margin:0 0 ' + (msgHtml ? '8px' : '14px') + '; font-size:1.12em;">' + _cmEsc(title) + '</h3>'
            + (msgHtml ? '<div style="color:var(--text-secondary); line-height:1.5; font-size:0.92em; margin-bottom:12px;">' + msgHtml + '</div>' : '')
            + '<input type="' + (opts.password ? 'password' : 'text') + '" class="form-control" id="_pmInput" placeholder="' + _cmEsc(opts.placeholder || '') + '" value="' + _cmEsc(defaultValue == null ? '' : defaultValue) + '" style="width:100%;">'
            + '<div class="btn-group" style="display:flex; justify-content:flex-end; gap:10px; margin-top:20px;">'
            +   '<button type="button" class="btn btn-secondary" data-pm="0">' + _cmEsc(cancelTxt) + '</button>'
            +   '<button type="button" class="btn" data-pm="1">' + _cmEsc(okTxt) + '</button>'
            + '</div>'
            + '</div>';
        var input = null;
        function cleanup(val) {
            document.removeEventListener('keydown', onKey, true);
            if (ov.parentNode) ov.parentNode.removeChild(ov);
            try { if (prev && prev.focus) prev.focus(); } catch (e) { logError('cleanup', e); }
            resolve(val);
        }
        function ok() { cleanup(input ? input.value : ''); }
        function onKey(e) {
            if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); cleanup(null); }
            else if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); ok(); }
        }
        ov.addEventListener('click', function (e) {
            if (e.target === ov) { cleanup(null); return; }
            var b = e.target.closest ? e.target.closest('[data-pm]') : null;
            if (b) { if (b.getAttribute('data-pm') === '1') ok(); else cleanup(null); }
        });
        document.addEventListener('keydown', onKey, true);
        document.body.appendChild(ov);
        input = ov.querySelector('#_pmInput');
        try { if (input) { input.focus(); input.select(); } } catch (e) { logError('onKey', e); }
    });
}
window.promptModal = promptModal;

/* Re-traduce datele demo din state la comutarea limbii (doar în modul demo). */
function retranslateDemoData() {
    try {
        if (!(typeof isDemoMode === 'function' && isDemoMode())) return;
        if (typeof state === 'undefined' || !state) return;
        var descMap = { 'Catan': 'demo.descCatan', 'Azul': 'demo.descAzul', 'Gloomhaven': 'demo.descGloomhaven', 'Ticket to Ride': 'demo.descTtr' };
        if (state.catalog) { Object.keys(descMap).forEach(function (g) { if (state.catalog[g]) state.catalog[g].description = t(descMap[g]); }); }
        if (Array.isArray(state.chatMessages)) { state.chatMessages.forEach(function (m) { if (m && m._demoKey) m.text = t(m._demoKey); }); }
        if (Array.isArray(state.polls)) { var p = state.polls.find(function (x) { return x && x.id === 'demo-poll-1'; }); if (p) p.question = t('demo.pollQuestion'); }
        if (Array.isArray(state.events)) { var ev = state.events.find(function (x) { return x && x.id === 'demo-event-1'; }); if (ev) { ev.title = t('demo.eventTitle'); ev.description = t('demo.eventDesc'); ev.location = t('demo.eventLocation'); } }
    } catch (e) { logError('retranslateDemoData', e); }
}
window.retranslateDemoData = retranslateDemoData;

function togglePasswordVisibility(id, btn) {
    var el = document.getElementById(id); if (!el) return;
    var willShow = el.type === 'password';
    el.type = willShow ? 'text' : 'password';
    var ic = btn && btn.querySelector('i');
    if (ic) ic.className = willShow ? 'fas fa-eye-slash' : 'fas fa-eye';
    if (btn) {
        var lbl = (typeof t === 'function') ? t(willShow ? 'login.hidePw' : 'login.showPw') : (willShow ? 'Ascunde parola' : 'Arată parola');
        btn.setAttribute('aria-label', lbl); btn.setAttribute('title', lbl);
    }
}

/* Pop-up bilingv de bun venit, afișat imediat după crearea unui cont nou. */
/* F1e (3 oct. 2026): bun-venitul rămâne „în așteptare" până când utilizatorul DECIDE (închide
   sau alege o acțiune). Dacă dispare altfel (o reîncărcare a paginii, o redesenare), reapare:
   după o reîncărcare îl reafișează onAuthenticated, iar pe aceeași pagină îl readuce
   supravegherea de mai jos (de cel mult două ori). EN: the welcome stays until the user decides. */
function _welcomeKeys() {
    var id = (state.currentUser && state.currentUser.id) || '';
    return { done: 'to_welcomed_' + id, pend: 'to_welcome_pending_' + id };
}
function welcomeDecide() {
    try { var k = _welcomeKeys(); localStorage.setItem(k.done, '1'); localStorage.removeItem(k.pend); } catch (e) { logError('welcomeDecide', e); }
}
window.welcomeDecide = welcomeDecide;
function _welcomeStillPending() {
    try { var k = _welcomeKeys(); return !!state.currentUser && localStorage.getItem(k.pend) === '1' && !localStorage.getItem(k.done); } catch (e) { return false; }
}
function _welcomeWatch(ms) {
    setTimeout(function () {
        if (document.getElementById('welcomeModal')) return;
        if ((window.__welcomeReshows || 0) >= 2) return;
        if (_welcomeStillPending()) { window.__welcomeReshows = (window.__welcomeReshows || 0) + 1; showWelcomeModal(); }
    }, ms);
}
function showWelcomeModal() {
    if (document.getElementById('welcomeModal')) return;
    var T = (typeof t === 'function') ? t : function (k, f) { return f || k; };
    var nm = (state.currentUser && (state.currentUser.displayName || state.currentUser.name)) || '';
    var modal = document.createElement('div');
    modal.className = 'modal active'; modal.id = 'welcomeModal';
    if (modal.dataset) modal.dataset.dynamic = '1';
    modal.onclick = function (e) { if (e.target === modal) { welcomeDecide(); modal.remove(); } };
    /* ★ T5: primul element, mare și vizibil = trial (doar DESCHIDE modalul de
       planuri — §32: activarea rămâne exclusiv server-side, din carduri).
       Apoi, în ordine: Discover clubs, Discover players, Complete your profile. */
    var row = function (where, icon, label) {
        return '<button class="btn btn-secondary" style="width:100%; display:flex; align-items:center; justify-content:center; gap:10px; padding:11px 14px;" onclick="welcomeGo(\'' + where + '\')">'
            + '<i class="fas ' + icon + '" style="color:var(--accent-primary,#ff6b35);"></i><span>' + label + '</span></button>';
    };
    modal.innerHTML =
        '<div class="modal-content" style="max-width:480px; text-align:center;">'
        + '<div style="font-size:2.6em; margin-bottom:6px;">🎲🎉</div>'
        + '<h2 style="margin:0 0 6px;">' + T('welcome.title', 'Bun venit în TurnOrder!') + (nm ? ', ' + _wEsc(nm) : '') + '</h2>'
        + '<p style="color:var(--text-secondary); margin:0 0 18px;">' + T('welcome.subtitle', 'Contul tău e gata. Hai să-ți pui clubul în mișcare!') + '</p>'
        + '<button class="btn btn-success" style="width:100%; display:flex; align-items:center; justify-content:center; gap:10px; font-size:1em; padding:12px 16px;" onclick="welcomeGo(\'trial\')">'
        +   '<i class="fas fa-gift"></i><span>' + T('trial.cta', 'Free 30-day trial, no card') + '</span></button>'
        + '<div style="display:flex; flex-direction:column; gap:8px; margin-top:12px;">'
        +   row('dclubs', 'fa-compass', T('discover.clubsTitle', 'Descoperă cluburi'))
        +   row('dplayers', 'fa-user-group', T('discover.playersTitle', 'Descoperă jucători'))
        +   row('profile', 'fa-id-card', T('welcome.btnProfile', 'Completează-ți profilul'))
        + '</div>'
        + '<div style="margin-top:14px;"><a href="javascript:void(0)" onclick="welcomeDecide(); document.getElementById(\'welcomeModal\').remove()" style="font-size:0.82em; color:var(--text-secondary);">' + T('welcome.btnLater', 'Mai târziu') + '</a></div>'
        + '</div>';
    document.body.appendChild(modal);
    _welcomeWatch(2500);
    _welcomeWatch(6000);
}
function _wEsc(s) { return window.escHtml(s); }
function welcomeGo(where) {
    welcomeDecide();
    var m = document.getElementById('welcomeModal'); if (m) m.remove();
    if (where === 'trial') { if (typeof openPlansModal === 'function') openPlansModal(); }
    else if (where === 'dclubs') { if (typeof openDiscoverClubs === 'function') openDiscoverClubs(); }
    else if (where === 'dplayers') { if (typeof openDiscoverPlayers === 'function') openDiscoverPlayers(); }
    else if (where === 'profile') { if (typeof openMyProfileModal === 'function') openMyProfileModal(); }
    else if (where === 'club') { if (typeof createClubPrompt === 'function') createClubPrompt(); }
    else { if (typeof openDiscoverClubs === 'function') openDiscoverClubs(); }
}

/* ===== Componenta 4 — condiționare în DOM a UI-ului sensibil după login =====
   Conținutul #mainApp (taburi, Panou Admin, Foaia de scor) e ÎNFĂȘURAT într-un
   wrapper #mainAppInner și FIZIC SCOS din DOM când nu ești logat — nu doar ascuns
   cu CSS. Astfel, dacă stilizarea pică, HTML-ul sensibil nu se randează deloc.
   Mutarea nodului (nu re-crearea din innerHTML) păstrează listenerii atașați.
   ★ FIX (dashboard gol la primul login): ambele helpere sunt IDEMPOTENTE.
   RO: un al doilea detach consecutiv (showWelcomeScreen la boot + resetAppState
       la login) crea un wrapper NOU și GOL peste referința reală din
       window._mainAppInnerNode → _attachMainApp atașa un div gol → UI blank
       până la refresh. Acum: detach-ul nu face nimic dacă e deja detașat, iar
       _ensureMainAppInner refolosește nodul real stocat în loc să creeze unul gol.
   EN: a second consecutive detach (welcome screen at boot + resetAppState on
       login) used to overwrite the stashed real node with a NEW EMPTY wrapper →
       _attachMainApp re-attached an empty div → blank UI until refresh. Now:
       detach is a no-op when already detached, and _ensureMainAppInner reuses
       the stashed real node instead of creating an empty one. */
function _ensureMainAppInner() {
    var ma = document.getElementById('mainApp');
    if (!ma) return null;
    var inner = document.getElementById('mainAppInner');
    if (!inner) {
        /* Dacă avem deja conținutul real detașat, refolosește-l — NU crea un
           wrapper gol peste el (am pierde definitiv UI-ul sensibil). */
        if (window._mainAppInnerNode) {
            ma.appendChild(window._mainAppInnerNode);
            return window._mainAppInnerNode;
        }
        inner = document.createElement('div');
        inner.id = 'mainAppInner';
        while (ma.firstChild) inner.appendChild(ma.firstChild);
        ma.appendChild(inner);
    }
    return inner;
}
function _detachMainApp() {
    try {
        /* Idempotent: dacă e deja detașat (nodul real e stocat și #mainAppInner
           nu mai există în DOM), nu facem nimic — evităm suprascrierea. */
        if (window._mainAppInnerNode && !document.getElementById('mainAppInner')) return;
        _ensureMainAppInner();
        var inner = document.getElementById('mainAppInner');
        if (inner && inner.parentNode) {
            window._mainAppInnerNode = inner;
            inner.parentNode.removeChild(inner);
        }
    } catch (e) { logError('_detachMainApp', e); }
}
function _attachMainApp() {
    try {
        var ma = document.getElementById('mainApp');
        if (!ma) return;
        if (document.getElementById('mainAppInner')) return; // deja atașat
        if (window._mainAppInnerNode) ma.appendChild(window._mainAppInnerNode);
        else _ensureMainAppInner();
    } catch (e) { logError('_attachMainApp', e); }
}
window._detachMainApp = _detachMainApp;
window._attachMainApp = _attachMainApp;

function showWelcomeScreen() {
    hideLoader(); /* ecran real afișat ⇒ loaderul se retrage (vezi nota de la hideLoader) */
    try { var _fab = document.getElementById('feedbackFab'); if (_fab) _fab.style.display = 'none'; } catch (e) { logError('showWelcomeScreen', e); }
    document.getElementById('welcomeScreen').classList.remove('hidden');
    document.getElementById('mainContainer').classList.add('hidden');
    /* 7.4: 'demoBar' — bara modului demo dispare la orice revenire pe ecranul de întâmpinare. */
    ['mainApp', 'clubHub', 'currentUserDisplay', 'notifBell', 'clubSwitcher', 'demoBar'].forEach(function (id) {
        var el = document.getElementById(id); if (el) el.classList.add('hidden');
    });
    /* F3 (3 oct. 2026): subsolul legal revine în poziția lui de pe ecranul de întâmpinare
       (după login fusese mutat în meniul lateral sau în hub-ul Profil, care tocmai s-au ascuns).
       `#mainApp` e deja ascuns mai sus, deci placeLegalFooter alege poziția originală. */
    try { if (typeof window.placeLegalFooter === 'function') window.placeLegalFooter(); } catch (e) { logError('showWelcomeScreen', e); }
    /* ⚠ ORICE revenire la ecranul de întâmpinare închide panourile care pot
       conține date ale contului tocmai părăsit — nu doar deconectarea explicită. */
    ['notifPanel', 'toastLogPanel'].forEach(function (id) {
        var el = document.getElementById(id); if (el) el.classList.add('hidden');
    });
    if (typeof closeTabMenu === 'function') closeTabMenu();
    ['quickSessionFab'].forEach(function (id) {
        var el = document.getElementById(id); if (el) el.style.display = 'none';
    });
    /* ⚡ PERF §54 (Batch 1b-fix): pornim scutul anti-bot DE AICI, nu abia din
       `showLogin()`.
       RO: ecranul ăsta se afișează EXCLUSIV utilizatorilor NElogați — `init()` trimite
           sesiunile valide direct în `runOnAuthenticated`, care nu trece niciodată pe
           aici. Deci câștigul de 133 kB pentru utilizatorii logați rămâne INTACT, dar
           cel care chiar are de făcut login primește avans: scutul se încarcă cât timp
           el citește pagina și apasă „Autentificare", nu abia după.
           DE CE: pe 3G, cele ~133 kB ale Turnstile nu apucau să ajungă în timpul în care
           utilizatorul tasta email+parolă, iar apăsarea pe „Conectare" pica.
       EN: this screen is shown only to signed-out users (valid sessions go straight to
           `runOnAuthenticated`), so the 133 kB saving for signed-in users is untouched
           while people who actually need the shield get a head start — on 3G it did not
           arrive in time when it only started at `showLogin()`. */
    try { if (typeof window.ensureTurnstile === 'function') window.ensureTurnstile(); } catch (e) { logError('showWelcomeScreen', e); }
    _detachMainApp();
}

/* Pe ecranele de autentificare bara afișează doar titlul (fără butoane de acțiune) */
function hideHeaderActions() {
    ['currentUserDisplay', 'notifBell', 'clubSwitcher', 'onlineBtn', 'settingsBtn'].forEach(function (id) {
        var el = document.getElementById(id); if (el) el.classList.add('hidden');
    });
    ['notifPanel', 'clubMenu', 'onlinePanel', 'settingsPanel', 'toastLogPanel'].forEach(function (id) {
        var el = document.getElementById(id); if (el) el.classList.add('hidden');
    });
}

function showLogin() {
    hideLoader(); /* ecran real afișat ⇒ loaderul se retrage (vezi nota de la hideLoader) */
    document.getElementById('welcomeScreen').classList.add('hidden');
    var _ceL = document.getElementById('confirmEmailScreen'); if (_ceL) _ceL.classList.add('hidden');
    document.getElementById('mainContainer').classList.remove('hidden');
    document.getElementById('loginScreen').classList.remove('hidden');
    document.getElementById('registerScreen').classList.add('hidden');
    document.getElementById('forgotPasswordScreen').classList.add('hidden');
    document.getElementById('mainApp').classList.add('hidden');
    var hub = document.getElementById('clubHub'); if (hub) hub.classList.add('hidden');
    hideHeaderActions();
    /* ⚡ PERF §54 (Batch 1b): pornim încărcarea scutului anti-bot ABIA acum, când
       formularul devine vizibil. „Trimite și uită" — NU se așteaptă, ca deschiderea
       cardului să rămână instantanee; utilizatorul are oricum de tastat email+parolă,
       timp în care widget-ul se randează. Plasa de siguranță e în `login()`, care
       așteaptă tokenul înainte de a-l citi.
       EN: fire-and-forget so opening the card stays instant; `login()` waits for the
       token before reading it. */
    try { if (typeof window.ensureTurnstile === 'function') window.ensureTurnstile(); } catch (e) { logError('showLogin', e); }
    if (typeof prefillLogin === 'function') prefillLogin();
}

function showRegister() {
    document.getElementById('welcomeScreen').classList.add('hidden');
    var _ceR = document.getElementById('confirmEmailScreen'); if (_ceR) _ceR.classList.add('hidden');
    document.getElementById('mainContainer').classList.remove('hidden');
    document.getElementById('loginScreen').classList.add('hidden');
    document.getElementById('registerScreen').classList.remove('hidden');
    document.getElementById('forgotPasswordScreen').classList.add('hidden');
    document.getElementById('mainApp').classList.add('hidden');
    var hubR = document.getElementById('clubHub'); if (hubR) hubR.classList.add('hidden');
    hideHeaderActions();
}

function showForgotPassword() {
    document.getElementById('loginScreen').classList.add('hidden');
    var _ceF = document.getElementById('confirmEmailScreen'); if (_ceF) _ceF.classList.add('hidden');
    document.getElementById('registerScreen').classList.add('hidden');
    document.getElementById('forgotPasswordScreen').classList.remove('hidden');
    document.getElementById('mainApp').classList.add('hidden');
    hideHeaderActions();
}

/* Ecranul „Confirmă-ți emailul", afișat imediat după înregistrare (când contul
   are nevoie de confirmare pe email). Arată adresa și oferă buton de retrimitere. */
function showConfirmEmail(email) {
    document.getElementById('welcomeScreen').classList.add('hidden');
    document.getElementById('mainContainer').classList.remove('hidden');
    document.getElementById('loginScreen').classList.add('hidden');
    document.getElementById('registerScreen').classList.add('hidden');
    document.getElementById('forgotPasswordScreen').classList.add('hidden');
    var ce = document.getElementById('confirmEmailScreen'); if (ce) ce.classList.remove('hidden');
    /* F1c: căsuțele codului se leagă (o singură dată), pornesc goale, cu focus pe prima. */
    try { if (typeof window.setupOtpBoxes === 'function') window.setupOtpBoxes(); if (typeof window.resetOtpBoxes === 'function') window.resetOtpBoxes(); } catch (e) { logError('showConfirmEmail', e); }
    /* F1d: primul email tocmai a plecat; serverul nu acceptă altul mai devreme de RESEND_WAIT_S. */
    try { var _rb = document.getElementById('resendConfirmBtn'); if (_rb && typeof window.startResendCountdown === 'function') window.startResendCountdown(_rb, window.RESEND_WAIT_S || 60); } catch (e) { logError('showConfirmEmail', e); }
    document.getElementById('mainApp').classList.add('hidden');
    var hubC = document.getElementById('clubHub'); if (hubC) hubC.classList.add('hidden');
    hideHeaderActions();
    if (email) {
        try { window._pendingConfirmEmail = email; } catch (e) { logError('showConfirmEmail', e); }
        var addr = document.getElementById('confirmEmailAddr'); if (addr) addr.textContent = email;
    }
}

/* Afișează formularul de setare a parolei noi (după ce s-a dat click pe linkul
   de resetare din email). Ascunde câmpul de email și butonul „Trimite cod",
   arată câmpul pentru parola nouă și butonul de resetare. */
function showRecoveryForm() {
    hideLoader(); /* ecran real afișat ⇒ loaderul se retrage (vezi nota de la hideLoader) */
    var wc = document.getElementById('welcomeScreen'); if (wc) wc.classList.add('hidden');
    var _ceRec = document.getElementById('confirmEmailScreen'); if (_ceRec) _ceRec.classList.add('hidden');
    var mc = document.getElementById('mainContainer'); if (mc) mc.classList.remove('hidden');
    document.getElementById('loginScreen').classList.add('hidden');
    document.getElementById('registerScreen').classList.add('hidden');
    document.getElementById('mainApp').classList.add('hidden');
    document.getElementById('forgotPasswordScreen').classList.remove('hidden');

    var emailInput = document.getElementById('resetEmail');
    if (emailInput && emailInput.closest('.form-group')) emailInput.closest('.form-group').classList.add('hidden');
    var sendBtn = document.getElementById('sendResetBtn');
    if (sendBtn) sendBtn.classList.add('hidden');
    var npg = document.getElementById('newPasswordGroup'); if (npg) npg.classList.remove('hidden');
    var rpb = document.getElementById('resetPasswordBtn'); if (rpb) rpb.classList.remove('hidden');

    showNotification(t('core.setNewPass'), 'info');
}

function showDemo() {
    // Auto login as demo user
    state.currentUser = {
        name: "Demo User",
        email: "demo@gbgsc.ro",
        isAdmin: true,
        isDemo: true
    };
    isAdmin = true;
    showMainApp();
    showNotification(t('core.demoOn'), 'info');
}

/* Funcțiile vechi `login()` și `register()` (bazate pe localStorage) au fost
   eliminate. Versiunile reale, bazate pe Supabase Auth, sunt definite în
   stratul de integrare Supabase de la finalul scriptului. */

async function sendResetCode() {
    const email = document.getElementById('resetEmail').value.trim();
    if (!email) {
        showNotification(t('core.enterEmail'), 'error');
        return;
    }
    showNotification(t('core.sendingReset'), 'info');
    /* Supabase trimite un email cu link de resetare a parolei. */
    const { error } = await sb.auth.resetPasswordForEmail(email, {
        redirectTo: window.location.href
    });
    if (error) {
        showNotification(t('core.errorColon') + error.message, 'error');
        return;
    }
    showNotification(t('core.resetSentMaybe'), 'success');
    showLogin();
}

/* Resetarea efectivă a parolei se face prin linkul din email (gestionat de
   Supabase). Funcția este păstrată pentru compatibilitate cu butonul din UI. */
async function resetPassword() {
    const newPassword = document.getElementById('resetNewPassword') ? document.getElementById('resetNewPassword').value : '';
    const _pw = (typeof checkPasswordRules === 'function') ? checkPasswordRules(newPassword) : { allMet: (newPassword || '').length >= 8 };
    if (!newPassword || !_pw.allMet) {
        showNotification((typeof t === 'function' ? t('pw.weak') : 'Parola nu e suficient de puternică: minim 8 caractere, literă mare, literă mică, cifră și un caracter special.'), 'error');
        return;
    }
    /* Asigură o sesiune de recuperare activă înainte de a schimba parola.
       1) Așteaptă puțin, în caz că Supabase încă procesează linkul.
       2) Dacă tot lipsește, reconstruiește sesiunea din token-urile din adresă. */
    async function getSess() {
        try { const r = await sb.auth.getSession(); return r && r.data ? r.data.session : null; }
        catch (e) { return null; }
    }
    let session = await getSess();
    for (let i = 0; i < 8 && !session; i++) {
        await new Promise(res => setTimeout(res, 400));
        session = await getSess();
    }
    if (!session) {
        const raw = (window.location.hash || '').replace(/^#/, '');
        const params = new URLSearchParams(raw);
        const at = params.get('access_token');
        const rt = params.get('refresh_token');
        if (at && rt) {
            try { await sb.auth.setSession({ access_token: at, refresh_token: rt }); } catch (e) { logError('getSess', e); }
            session = await getSess();
        }
    }
    if (!session) {
        showNotification(t('core.resetLinkExpired'), 'error');
        return;
    }

    const { error } = await sb.auth.updateUser({ password: newPassword });
    if (error) {
        showNotification(t('core.errorColon') + error.message + t('core.resetOpenLinkSuffix'), 'error');
        return;
    }
    /* Curăță „biletul" de resetare din adresă și restabilește formularul */
    try { history.replaceState(null, '', window.location.pathname + window.location.search); } catch (e) { logError('getSess', e); }
    try { await sb.auth.signOut(); } catch (e) { logError('getSess', e); }
    var emailGrp = document.getElementById('resetEmail');
    if (emailGrp && emailGrp.closest('.form-group')) emailGrp.closest('.form-group').classList.remove('hidden');
    var sBtn = document.getElementById('sendResetBtn'); if (sBtn) sBtn.classList.remove('hidden');
    var npg2 = document.getElementById('newPasswordGroup'); if (npg2) npg2.classList.add('hidden');
    var rpb2 = document.getElementById('resetPasswordBtn'); if (rpb2) rpb2.classList.add('hidden');
    showNotification(t('core.passUpdated'), 'success');
    showLogin();
}

async function logout() {
    if (typeof window.t === 'function' && !await confirmModal(window.t('logout.confirm'))) return;
    if (state.currentUser) {
        addAuditLog('audit.logout', state.currentUser.name, `IP: ${getUserIP()}, Durată sesiune: ${getSessionDuration()}`);
        updateOnlineStatus(false);
    }
    
    // Reset demo if it was a demo session
    if (state.currentUser?.isDemo) {
        state = {
            version: "3.0",
            users: {},
            currentUser: null,
            members: {},
            games: [],
            catalog: {},
            categories: [...DEFAULT_CATEGORIES],
            polls: [],
            chatMessages: [],
            regulation: { version: "1.0", lastModified: new Date().toISOString(), articles: [] },
            seasons: [],
            currentSeason: new Date().getFullYear(),
            locations: [],
            audit: [],
            events: [],
            backups: [],
            settings: {
                pointsPerWin: 3,
                pointsPerSecond: 2,
                pointsPerThird: 1,
                pointsPerParticipation: 0.5,
                chatNotifications: true,
                emailNotifications: false,
                theme: "dark",
                language: "ro"
            },
            onlineUsers: {},
            notifications: []
        };
        initDemoData();
    }
    
    state.currentUser = null;
    isAdmin = false;

    /* Oprim auto-login-ul și ștergem parola salvată (păstrăm email-ul pentru precompletare). */
    try {
        localStorage.setItem('gbgsc_remember', '0');
        localStorage.removeItem('gbgsc_pass');
        sessionStorage.removeItem('gbgsc_tab');
    } catch (e) { logError('logout', e); }
    try { await sb.auth.signOut(); } catch (e) { logError('logout', e); }

    showWelcomeScreen();
    showNotification(t('core.loggedOut'), 'success');
}

/* ================= HELPER FUNCTIONS ================= */
function getUserIP() {
    // This is a simplified version. In a real app, you'd get this from the server
    return 'local';
}

function getSessionDuration() {
    // Calculate session duration
    if (state.currentUser && state.currentUser.lastLogin) {
        const loginTime = new Date(state.currentUser.lastLogin);
        const now = new Date();
        const diff = now - loginTime;
        const minutes = Math.floor(diff / 60000);
        return t('session.minutesShort').replace('{n}', String(minutes));
    }
    return t('common.unknownF');
}

/* ================= MAIN APP ================= */
function showMainApp() {
    /* Loaderul se retrage AICI, nu în `init()`. Restul funcției e sincron până la
       `render()`, iar fade-ul CSS durează 500 ms — deci nu se vede interfața
       pe jumătate randată. */
    hideLoader();
    _attachMainApp();
    document.getElementById('welcomeScreen').classList.add('hidden');
    var _ceM = document.getElementById('confirmEmailScreen'); if (_ceM) _ceM.classList.add('hidden');
    document.getElementById('mainContainer').classList.remove('hidden');
    document.getElementById('loginScreen').classList.add('hidden');
    document.getElementById('registerScreen').classList.add('hidden');
    document.getElementById('forgotPasswordScreen').classList.add('hidden');
    document.getElementById('mainApp').classList.remove('hidden');
    const cs = document.getElementById('clubSwitcher'); if (cs) cs.classList.remove('hidden');
    const bell = document.getElementById('notifBell'); if (bell) bell.classList.remove('hidden');
    try { if (typeof renderClubSwitcher === 'function') renderClubSwitcher(); } catch (e) { logError('showMainApp', e); }
    
    // Update user display
    updateUserDisplay();
    
    // Render everything
    render();
    
    // Start chat
    loadChat();
    
    // Load online users
    loadOnlineUsers();
    
    // Start periodic updates
    startPeriodicUpdates();

    // Buton plutitor (+) + meniul de taburi pe tot ecranul
    ensureQuickSessionFab();
    ensureTabMenu();

    // Deep-link: onorează hash-ul de boot (ex. #polls) O SINGURĂ DATĂ, la cold-start.
    try {
        if (!_deepLinkHandled) {
            _deepLinkHandled = true;
            if (_bootHash && _bootHash !== currentTab && document.getElementById('tab-' + _bootHash)) switchTab(_bootHash);
        }
    } catch (e) { logError('showMainApp', e); }

    // Reluăm un deep-link push reținut cât userul era nelogat (vezi _pushRoute).
    try {
        if (window._pendingPushRoute) {
            var _pr = window._pendingPushRoute; window._pendingPushRoute = null;
            setTimeout(function () { try { _pushRoute(_pr); } catch (e) { logError('showMainApp', e); } }, 400);
        }
    } catch (e) { logError('showMainApp', e); }
}

/* ============== TurnOrder — Hub cluburi ============== */
function showClubHub() {
    hideLoader(); /* ecran real afișat ⇒ loaderul se retrage (vezi nota de la hideLoader) */
    _attachMainApp();
    document.getElementById('welcomeScreen').classList.add('hidden');
    var _ceH = document.getElementById('confirmEmailScreen'); if (_ceH) _ceH.classList.add('hidden');
    document.getElementById('mainContainer').classList.remove('hidden');
    document.getElementById('loginScreen').classList.add('hidden');
    document.getElementById('registerScreen').classList.add('hidden');
    document.getElementById('forgotPasswordScreen').classList.add('hidden');
    document.getElementById('mainApp').classList.add('hidden');
    document.getElementById('clubHub').classList.remove('hidden');
    setLastView('hub');
    if (typeof closeTabMenu === 'function') closeTabMenu();
    ['quickSessionFab'].forEach(id => { const f = document.getElementById(id); if (f) f.style.display = 'none'; });
    updateUserDisplay();
    /* Clopoțelul rămâne (notificări cross-club); pill-ul de club îl gestionează renderClubSwitcher (apare dacă ai cluburi) */
    const bell = document.getElementById('notifBell'); if (bell) bell.classList.remove('hidden');
    if (typeof renderClubSwitcher === 'function') renderClubSwitcher();
    if (typeof refreshOnlineBadge === 'function') refreshOnlineBadge();
    renderClubHub();
    refreshClubStats().then(() => {
        const hub = document.getElementById('clubHub');
        if (hub && !hub.classList.contains('hidden')) renderClubHub();
    });
}

function clubTimeAgoShort(ms) {
    if (!ms) return null;
    const d = Math.floor((Date.now() - ms) / 86400000);
    if (d <= 0) return window.t('time.today');
    if (d === 1) return window.t('time.yesterday');
    if (d < 30) return window.t('time.daysAgo').replace('{n}', d);
    if (d < 60) return window.t('time.monthAgo');
    if (d < 365) return window.t('time.monthsAgo').replace('{n}', Math.floor(d / 30));
    return new Date(ms).toLocaleDateString('en-GB');
}

async function refreshClubStats() {
    state.clubStats = state.clubStats || {};
    const ids = (state.myClubs || []).map(c => c.id);
    if (!sb || !ids.length || (state.currentUser && state.currentUser.isDemo)) return;
    try {
        const mres = await sb.from('club_members').select('club_id').in('club_id', ids).eq('status', 'active');
        const counts = {};
        (mres.data || []).forEach(r => { counts[r.club_id] = (counts[r.club_id] || 0) + 1; });
        const sres = await sb.from('matches').select('club_id, date').in('club_id', ids).order('date', { ascending: false });
        const lastSession = {};
        (sres.data || []).forEach(r => { if (!lastSession[r.club_id]) lastSession[r.club_id] = r.date; });
        ids.forEach(id => {
            const t = lastSession[id] ? new Date(lastSession[id]).getTime() : null;
            state.clubStats[id] = { members: counts[id] || 0, lastSession: t };
        });
    } catch (e) { console.warn('refreshClubStats:', e && e.message); }
}

function renderClubHub() {
    const list = document.getElementById('clubHubList');
    const actions = document.getElementById('clubHubActions');
    if (!list) return;
    const allClubs = state.myClubs || [];
    const stats = state.clubStats || {};

    // Iconița de search lângă titlu — doar când există cluburi
    const searchToggle = document.getElementById('clubHubSearchToggle');
    if (searchToggle) searchToggle.style.display = allClubs.length ? '' : 'none';
    const term = (window._clubHubSearch || '').toLowerCase();
    const clubs = term ? allClubs.filter(c => (c.name || '').toLowerCase().includes(term)) : allClubs;

    if (!allClubs.length) {
        list.innerHTML = `<div class="card" style="text-align:center;"><p style="opacity:0.85;">${t('hub.noClubs')}<br>${canCreateClub() ? t('hub.createClub') : t('hub.discoverClubs')}</p></div>`;
    } else if (!clubs.length) {
        list.innerHTML = `<div class="club-hub-empty"><i class="fas fa-magnifying-glass" style="font-size:2em; display:block; margin-bottom:10px; opacity:.6;"></i>${t('hub.noMatch')}</div>`;
    } else {
        list.innerHTML = clubs.map(c => {
            const st = stats[c.id] || {};
            const tag = (c.status && c.status !== 'active')
                ? ` <span style="font-size:0.65em; background:#b23b3b; color:#fff; border-radius:6px; padding:1px 6px; vertical-align:middle;">${clubStatusLabel(c.status)}</span>` : '';
            const pend = (state.pendingByClub && state.pendingByClub[c.id])
                ? ` <span style="font-size:0.7em; background:#e74c3c; color:#fff; border-radius:8px; padding:1px 7px;">${state.pendingByClub[c.id]} cereri</span>` : '';
            const initial = (c.name || '?').trim().charAt(0).toUpperCase();
            const avatar = c.imageUrl
                ? `<img src="${clubEsc(c.imageUrl)}" onclick="event.stopPropagation(); if(typeof openLightbox==='function') openLightbox('${window.attrJs(c.imageUrl)}')" style="width:48px; height:48px; border-radius:12px; object-fit:cover; flex:none; cursor:zoom-in;">`
                : `<div style="width:48px; height:48px; border-radius:12px; flex:none; background:var(--gradient-primary,#ff6b35); color:#fff; display:flex; align-items:center; justify-content:center; font-weight:800; font-size:1.3em;">${clubEsc(initial)}</div>`;
            const members = (st.members != null) ? `<i class="fas fa-users"></i> ${st.members} ${st.members === 1 ? window.t('club.memberOne') : window.t('club.memberMany')}` : '';
            const last = st.lastSession ? ` &middot; <i class="fas fa-dice"></i> ${window.t('club.lastSession')} ${clubTimeAgoShort(st.lastSession)}` : (st.members != null ? ' &middot; ' + window.t('club.noSessionsYet') : '');
            const action = (typeof clubActionForMe === 'function') ? clubActionForMe(c) : null;
            const rightSide = action
                ? claimClubButtonHtml(c, { small: true })
                : `<div style="flex:none; width:36px; height:36px; border-radius:50%; background:var(--gradient-primary,#ff6b35); color:#fff; display:flex; align-items:center; justify-content:center; box-shadow:0 2px 8px rgba(255,107,53,0.35);"><i class="fas fa-arrow-right"></i></div>`;
            return `<div class="card" style="display:flex; align-items:center; gap:12px; margin-bottom:10px; cursor:pointer; flex-wrap:nowrap;" onclick="${c.status === 'pending' ? `resumeClubPayment('${c.id}')` : `enterClub('${c.id}')`}">
                ${avatar}
                <div style="min-width:0; flex:1; overflow:hidden;">
                    <div class="club-hub-name" title="${clubEsc(c.name)}">${clubEsc(c.name)}${tag}</div>
                    <div style="font-size:0.78em; opacity:0.7; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">${clubRoleLabel(c.myRole)}${typeof planTagHtml === 'function' ? planTagHtml(c) : ''}${pend}</div>
                    <div class="club-hub-meta">${members}${last}</div>
                </div>
                ${rightSide}
            </div>`;
        }).join('');
    }
    if (actions) {
        actions.innerHTML = `
            ${canCreateClub() ? `<button class="btn btn-primary" onclick="createClubPrompt()"><i class="fas fa-plus"></i> ${t('hub.createClub')}</button>` : ''}
            <button class="btn btn-outline" onclick="openMyProfileModal()"><i class="fas fa-user"></i> ${t('nav.profile')}</button>
            <button class="btn btn-outline" onclick="openDiscoverClubs()"><i class="fas fa-compass"></i> ${t('hub.discoverClubs')}</button>
            <button class="btn btn-outline" onclick="openDiscoverPlayers()"><i class="fas fa-user-group"></i> ${t('hub.discoverPlayers')}</button>
            <button class="btn btn-outline" data-keeps-popup onclick="toggleSettingsPanel(this)"><i class="fas fa-cog"></i> ${t('settings.title')}</button>
            <button class="btn btn-outline" onclick="openPlansModal()"><i class="fas fa-rocket"></i> ${t('hub.plans')}</button>
            <button class="btn btn-outline" id="pwaInstallBtn" onclick="installPwa()" style="display:${_toIsStandalone() ? 'none' : ''};"><i class="fas fa-download"></i> ${t('hub.install')}</button>
            ${isPlatformOwner() && !(typeof isDemoMode === 'function' && isDemoMode()) ? `<button class="btn btn-outline" onclick="openOwnerPanel()"><i class="fas fa-user-shield"></i> ${t('hub.ownerPanel')}</button>` : ''}
            <button class="btn btn-outline" onclick="logout()"><i class="fas fa-sign-out-alt"></i> ${t('hub.logout')}</button>`;
    }
}

function clubHubSearch(v) {
    window._clubHubSearch = (v || '').trim();
    renderClubHub();
}
window.clubHubSearch = clubHubSearch;

function toggleClubHubSearch() {
    const wrap = document.getElementById('clubHubSearchWrap');
    const btn = document.getElementById('clubHubSearchToggle');
    if (!wrap) return;
    const open = wrap.classList.toggle('hidden') === false;
    if (btn) btn.classList.toggle('is-on', open);
    const inp = document.getElementById('clubHubSearch');
    if (open) {
        if (inp) setTimeout(() => inp.focus(), 30);
    } else {
        if (inp) inp.value = '';
        window._clubHubSearch = '';
        renderClubHub();
    }
}
window.toggleClubHubSearch = toggleClubHubSearch;

/* F1 (3 oct. 2026): `opts.force` trece mai departe la switchClub, ca un club deja selectat, dar
   neîncărcat (după o invitație), să-și încarce datele. EN: pass `force` through to switchClub. */
async function enterClub(clubId, opts) {
    const force = !!(opts && opts.force);
    if (clubId && (clubId !== currentClubId || force)) { await switchClub(clubId, opts); }
    setLastView('club');
    document.getElementById('clubHub').classList.add('hidden');
    showMainApp();
    /* Intrarea explicită într-un club pornește mereu pe Dashboard (nu pe tabul vizitat în alt club). */
    try { if (currentTab !== 'dashboard' && document.getElementById('tab-dashboard')) switchTab('dashboard'); } catch (e) { logError('enterClub', e); }
}

function goHome() {
    if (!state.currentUser || state.currentUser.isDemo) return;
    showClubHub();
}

/* ============== „Ce jucăm diseară?" — recomandare jocuri ============== */
/* Buton plutitor (+) — deschide meniul de taburi pe tot ecranul; devine X când e deschis. */
function ensureQuickSessionFab() {
    var existing = document.getElementById('quickSessionFab');
    if (existing) { existing.style.display = 'flex'; return; }
    var fab = document.createElement('button');
    fab.id = 'quickSessionFab';
    fab.title = window.t('tabmenu.open');
    fab.setAttribute('data-i18n-title', 'tabmenu.open');
    fab.innerHTML = '<i class="fas fa-plus"></i>';
    fab.style.cssText = 'position:fixed;right:calc(20px + env(safe-area-inset-right, 0px));bottom:calc(20px + env(safe-area-inset-bottom, 0px));z-index:9000;width:58px;height:58px;border:none;border-radius:50%;cursor:pointer;font-size:22px;color:#fff;background:var(--success,#27ae60);box-shadow:0 6px 20px rgba(0,0,0,0.45);display:flex;align-items:center;justify-content:center;transition:background .15s, transform .15s;';
    fab.onclick = toggleTabMenu;
    document.body.appendChild(fab);
}

/* ====== Meniul de taburi pe tot ecranul ====== */
function ensureTabMenu() {
    if (document.getElementById('tabMenuOverlay')) return;
    // Overlay (doar grila) — are backdrop-filter, deci NU punem butoane fixed înăuntru
    var ov = document.createElement('div');
    ov.id = 'tabMenuOverlay';
    ov.className = 'hidden';
    ov.innerHTML = '<div class="tab-menu-grid" id="tabMenuGrid"></div>';
    ov.addEventListener('click', function (e) { if (e.target === ov) closeTabMenu(); });
    document.body.appendChild(ov);
    // Butoanele rotunde shortcut — la nivel de body (fixe față de viewport, corect și în landscape)
    if (!document.getElementById('tabMenuFabs')) {
        var fabs = document.createElement('div');
        fabs.id = 'tabMenuFabs';
        fabs.className = 'tab-menu-fabs hidden';
        fabs.innerHTML =
            '<button type="button" class="tmf-btn tmf-history" id="tmfHistory" title="Istoric" data-i18n-title="nav.history" onclick="switchTab(\'history\'); closeTabMenu();"><i class="fas fa-history"></i></button>' +
            '<button type="button" class="tmf-btn tmf-players" id="tmfPlayers" title="Jucători" data-i18n-title="nav.players" onclick="switchTab(\'players\'); closeTabMenu();"><i class="fas fa-users"></i></button>' +
            '<button type="button" class="tmf-btn tmf-play" id="tmfPlay" title="Sesiune" data-i18n-title="nav.session" onclick="switchTab(\'session\'); closeTabMenu();"><i class="fas fa-gamepad"></i></button>';
        document.body.appendChild(fabs);
    }
    if (typeof applyTranslations === 'function') { try { applyTranslations(); } catch (e) { logError('ensureTabMenu', e); } }
}

/* Construiește grila de taburi din nav-ul existent (respectă capabilitățile + i18n live) */
function buildTabMenuGrid() {
    var grid = document.getElementById('tabMenuGrid');
    if (!grid) return;
    var html = '';
    document.querySelectorAll('.tabs .tab').forEach(function (tab) {
        var name = tab.getAttribute('data-tab');
        // logout/profil sunt în Setări/header; session/players/history sunt în butoanele rotunde de jos
        if (!name || { logout: 1, profile: 1, session: 1, players: 1, history: 1 }[name]) return;
        if (typeof canAccessTab === 'function' && !canAccessTab(name)) return; // respectă rolul
        var iconEl = tab.querySelector('i');
        var icon = iconEl ? iconEl.className : 'fas fa-circle';
        var labelEl = tab.querySelector('span[data-i18n]');
        var key = labelEl ? labelEl.getAttribute('data-i18n') : '';
        var label = labelEl ? labelEl.textContent : name;
        html += '<button type="button" class="tab-card" onclick="switchTab(\'' + name + '\'); closeTabMenu();">' +
            '<i class="' + icon + '"></i>' +
            '<span' + (key ? ' data-i18n="' + key + '"' : '') + '>' + label + '</span></button>';
    });
    grid.innerHTML = html;
    if (typeof applyTranslations === 'function') { try { applyTranslations(); } catch (e) { logError('buildTabMenuGrid', e); } }
}

var _tabMenuOpen = false;
function openTabMenu() {
    ensureTabMenu();
    var ov = document.getElementById('tabMenuOverlay');
    if (!ov) return;
    buildTabMenuGrid();
    // gating capabilități pe scurtături
    [['tmfHistory', 'history'], ['tmfPlayers', 'players'], ['tmfPlay', 'session']].forEach(function (pair) {
        var el = document.getElementById(pair[0]);
        if (el) el.style.display = (typeof canAccessTab === 'function' && !canAccessTab(pair[1])) ? 'none' : '';
    });
    ov.classList.remove('hidden');
    var fabsRow = document.getElementById('tabMenuFabs');
    if (fabsRow) fabsRow.classList.remove('hidden');
    var fab = document.getElementById('quickSessionFab');
    if (fab) {
        fab.classList.add('is-x');
        fab.innerHTML = '<i class="fas fa-times"></i>';
        fab.title = (typeof t === 'function') ? t('tabmenu.close') : 'Close';
        fab.setAttribute('data-i18n-title', 'tabmenu.close');
    }
    document.body.style.overflow = 'hidden';
    _tabMenuOpen = true;
}
function closeTabMenu() {
    var ov = document.getElementById('tabMenuOverlay');
    if (ov) ov.classList.add('hidden');
    var fabsRow = document.getElementById('tabMenuFabs');
    if (fabsRow) fabsRow.classList.add('hidden');
    var fab = document.getElementById('quickSessionFab');
    if (fab) {
        fab.classList.remove('is-x');
        fab.innerHTML = '<i class="fas fa-plus"></i>';
        fab.title = (typeof t === 'function') ? t('tabmenu.open') : '';
        fab.setAttribute('data-i18n-title', 'tabmenu.open');
    }
    document.body.style.overflow = '';
    _tabMenuOpen = false;
}
function toggleTabMenu() { if (_tabMenuOpen) closeTabMenu(); else openTabMenu(); }

/* ====== Localizare dată/oră (folosit în toată aplicația) ====== */
function appLangCode() { try { return (typeof currentLang !== 'undefined' && currentLang === 'en') ? 'en' : 'ro'; } catch (e) { return 'ro'; } }
function appDateLocale() { return appLangCode() === 'en' ? 'en-GB' : 'ro-RO'; } // date cu opțiuni (luni etc.)
function appTimeLocale() { return appLangCode() === 'en' ? 'en-US' : 'ro-RO'; } // RO=24h, EN=AM/PM
try { window.appLangCode = appLangCode; window.appDateLocale = appDateLocale; window.appTimeLocale = appTimeLocale; } catch (e) { logError('appTimeLocale', e); }

/* ===== ARITMETICĂ PE LUNI, FĂRĂ DEPĂȘIRE =====================================
   RO: `d.setMonth(d.getMonth() - 1)` NU limitează ziua. Pe 31 iulie, „iunie"
       devine 31 iunie, iar JavaScript îl mută tăcut în 1 IULIE. Efectele reale,
       toate dependente de ziua în care se deschide aplicația:
         · graficul „Performanță lunară" din dashboard afișa aceeași lună de două
           ori și pierdea complet o lună — pe 31 ianuarie ar fi pierdut februarie
           și ar fi dublat august, octombrie și decembrie;
         · numărătoarea sesiunilor era greșită, nu doar eticheta: bara „iunie"
           număra sesiunile din iulie;
         · filtrele „ultima lună" / „ultimele 3 luni" din Statistici și Istoric
           alunecau cu până la 3 zile;
         · o serie de evenimente lunare pornită pe 31 ianuarie sărea peste
           februarie și genera 3 martie.
       `addMonths` limitează ziua la ultima zi a lunii țintă: 31 ian + 1 lună =
       28/29 feb, nu 3 martie. Aceeași regulă pentru ani (29 feb -> 28 feb).
   EN: month arithmetic that clamps the day instead of overflowing into the next
       month — the source of duplicated months in the dashboard chart.
   ⚠ Orice calcul cu luni sau ani se face PRIN funcțiile astea, niciodată direct
     cu setMonth/setFullYear.
   ============================================================================ */
function addMonths(base, delta) {
    const d = new Date(base);
    const zi = d.getDate();
    d.setDate(1);                                   /* întâi ziua sigură, apoi luna */
    d.setMonth(d.getMonth() + delta);
    const ultima = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
    d.setDate(Math.min(zi, ultima));
    return d;
}
function addYears(base, delta) { return addMonths(base, delta * 12); }
function addDays(base, delta) { const d = new Date(base); d.setDate(d.getDate() + delta); return d; }
/* Începutul lunii care conține data dată — granița stabilă pentru „luna X". */
function startOfMonth(base) { const d = new Date(base); d.setHours(0, 0, 0, 0); d.setDate(1); return d; }
try { window.addMonths = addMonths; window.addYears = addYears; window.addDays = addDays; window.startOfMonth = startOfMonth; } catch (e) {}



/* ====== Tab Sesiuni: descriere mod + opțiuni expandabile ====== */
function sessModeDescUpdate() {
    var d = document.getElementById('sessModeDesc');
    if (!d) return;
    var typ = (typeof currentSessionType !== 'undefined' && currentSessionType) ? currentSessionType : 'standard';
    var key = typ === 'tournament' ? 'session.descTournament' : (typ === 'coop' ? 'session.descCoop' : 'session.descStandard');
    d.setAttribute('data-i18n', key);
    if (typeof t === 'function') d.textContent = t(key);
}

function toggleSessionExtra(key, tileEl) {
    var panel = document.getElementById('sessExtra-' + key);
    if (!panel) return;
    var willOpen = panel.classList.contains('hidden');
    panel.classList.toggle('hidden', !willOpen);
    if (tileEl) tileEl.classList.toggle('is-open', willOpen);
}

/* Toggle generic pentru orice panou ascuns + tile (Players etc.) */
function toggleTilePanel(panelId, tileEl) {
    var panel = document.getElementById(panelId);
    if (!panel) return;
    var willOpen = panel.classList.contains('hidden');
    panel.classList.toggle('hidden', !willOpen);
    if (tileEl) tileEl.classList.toggle('is-open', willOpen);
}

function sessExtraSyncFriendly() {
    var cb = document.getElementById('sessionFriendly');
    var tile = document.getElementById('sessTile-friendly');
    if (tile && cb) tile.classList.toggle('is-on', !!cb.checked);
}


function gnSuggest(randomPick) {
    var box = document.getElementById('gnResults');
    if (!box) return;
    var esc = function (s) { return window.escHtml(s); };
    var inp = document.getElementById('gnPlayers');
    var n = parseInt(inp && inp.value) || 0;
    var catalog = state.catalog || {};
    var eligible = Object.keys(catalog).map(function (title) { return { title: title, g: catalog[title] }; })
        .filter(function (item) {
            if (!n) return true;
            var min = item.g.minPlayers, max = item.g.maxPlayers;
            var okMin = (min == null) || (n >= min);
            var okMax = (max == null) || (n <= max);
            return okMin && okMax;
        });
    if (eligible.length === 0) {
        box.innerHTML = '<p style="color:var(--text-secondary);text-align:center;padding:20px;">' + window.t('catalog.noFitForN').replace('{n}', n) + '</p>';
        return;
    }
    eligible.sort(function (a, b) {
        var la = a.g.lastPlayed ? new Date(a.g.lastPlayed).getTime() : 0;
        var lb = b.g.lastPlayed ? new Date(b.g.lastPlayed).getTime() : 0;
        if (la !== lb) return la - lb;
        return (a.g.timesPlayed || 0) - (b.g.timesPlayed || 0);
    });
    var list = randomPick ? [eligible[Math.floor(Math.random() * eligible.length)]] : eligible.slice(0, 6);
    box.innerHTML = list.map(function (item, i) {
        var g = item.g;
        var range = (g.minPlayers && g.maxPlayers)
            ? (g.minPlayers === g.maxPlayers ? ('' + g.minPlayers) : (g.minPlayers + '-' + g.maxPlayers))
            : (g.players || '?');
        var last = g.lastPlayed ? new Date(g.lastPlayed).toLocaleDateString('en-GB') : t('common.never');
        var dur = g.duration ? (g.duration + ' min') : '—';
        var isTop = (!randomPick && i === 0);
        var border = isTop ? 'border:2px solid var(--accent-gold,#ffd700);' : 'border:1px solid var(--border,#3a4466);';
        return '<div style="' + border + 'background:var(--bg-card,#252b4a);border-radius:10px;padding:12px 14px;margin-bottom:10px;">' +
            '<div style="display:flex;justify-content:space-between;align-items:center;gap:8px;">' +
                '<strong style="font-size:1.05em;">' + (isTop ? '⭐ ' : '') + esc(item.title) + '</strong>' +
                '<span style="color:var(--text-secondary);font-size:.85em;white-space:nowrap;"><i class="fas fa-users"></i> ' + esc(range) + '</span>' +
            '</div>' +
            '<div style="color:var(--text-secondary);font-size:.85em;margin-top:6px;">' +
                '<i class="fas fa-clock"></i> ' + esc(dur) + ' &nbsp;·&nbsp; <i class="fas fa-history"></i> ' + t('gv.lastPlayed') + ' ' + esc(last) +
            '</div>' +
        '</div>';
    }).join('');
}

function gnStartVote() {
    var inp = document.getElementById('gnPlayers');
    var n = parseInt(inp && inp.value) || 0;
    /* 8.16-3d: votul „Ce jucăm" e în polls.js, încărcat la cerere ⇒ încarcă, apoi pornește. */
    var go = function () {
        var cands = gvSuggestCandidates(n, 6);
        if (cands.length === 0) { showNotification(t('core.noGamesForVote'), 'error'); return; }
        var modal = document.querySelector('.modal.active'); if (modal) modal.remove();
        startGameVote(cands);
    };
    if (window.TO_CHAT && window.TO_CHAT.readyModule && window.TO_CHAT.readyModule('TO_POLLS')) go();
    else if (window.TO_CHAT && window.TO_CHAT.useModule) window.TO_CHAT.useModule('polls.js', 'TO_POLLS', go);
}

function updateUserDisplay() {
    try { var _fab = document.getElementById('feedbackFab'); if (_fab) _fab.style.display = state.currentUser ? 'inline-flex' : 'none'; } catch (e) { logError('updateUserDisplay', e); }
    if (state.currentUser) {
        document.getElementById('currentUserDisplay').classList.remove('hidden');
        document.getElementById('userName').textContent = state.currentUser.name;
        const av = document.getElementById('userAvatar');
        if (av) {
            const u = (state.currentUser.email && state.users[state.currentUser.email]) || {};
            const a = state.currentUser.avatar || u.avatar || '';
            if (!a) {
                av.innerHTML = '<i class="fas fa-user"></i>';
            } else if (typeof isPhotoAvatar === 'function' && isPhotoAvatar(a)) {
                // Poză de profil (data URL/http) — randează ca imagine rotundă, nu ca text brut.
                av.innerHTML = '<img src="' + window.escHtml(a) + '" style="width:24px;height:24px;border-radius:50%;object-fit:cover;vertical-align:middle;display:block;">';
            } else {
                av.textContent = a; // emoji — ca text, nu HTML (v9 S1) / as text, not HTML
            }
        }
        
        var roleEl = document.getElementById('userRoleBadge');
        if (roleEl) {
            var _role = (typeof currentClubMyRole === 'function') ? currentClubMyRole() : null;
            if (!_role && state.currentUser.isAdmin) _role = 'principal_admin';
            if (_role) {
                var _slug = ({ principal_admin: 'principal', secondary_admin: 'secondary', moderator: 'moderator', member: 'member' })[_role] || 'member';
                roleEl.setAttribute('data-i18n', 'role.' + _slug); // traducere live
                roleEl.textContent = (typeof clubRoleLabel === 'function') ? clubRoleLabel(_role) : '';
                roleEl.className = 'role-pill role-' + _slug;
            } else {
                roleEl.removeAttribute('data-i18n');
                roleEl.className = 'role-pill hidden';
            }
        }
        if (typeof renderNotifBadge === 'function') renderNotifBadge();
        if (typeof renderClubSwitcher === 'function') renderClubSwitcher();
        var _set = document.getElementById('settingsBtn'); if (_set) _set.classList.remove('hidden');
        var _onl = document.getElementById('onlineBtn'); if (_onl) _onl.classList.remove('hidden');
    } else {
        const disp = document.getElementById('currentUserDisplay');
        if (disp) disp.classList.add('hidden');
        const bell = document.getElementById('notifBell');
        if (bell) bell.classList.add('hidden');
        const cs = document.getElementById('clubSwitcher');
        if (cs) cs.classList.add('hidden');
        var _set2 = document.getElementById('settingsBtn'); if (_set2) _set2.classList.add('hidden');
        var _onl2 = document.getElementById('onlineBtn'); if (_onl2) _onl2.classList.add('hidden');
    }
}

/* ===== Popup-uri header: Setări + Online (ancorate sub butonul lor) ===== */
function closeHeaderPopups(exceptId) {
    ['notifPanel', 'clubMenu', 'onlinePanel', 'settingsPanel', 'toastLogPanel'].forEach(function (id) {
        if (id === exceptId) return;
        var el = document.getElementById(id);
        if (el) el.classList.add('hidden');
    });
}

/* Layout dedicat popup-ului Setări pentru abonament (aceleași date/acțiuni ca în profil, aspect aerisit) */
function settingsSubHTML() {
    var T = (typeof t === 'function') ? t : function (k) { return k; };
    var plan = (typeof userActivePlan === 'function') ? userActivePlan() : null;
    if (!plan) {
        return '<div class="sub-card sub-card-empty">' +
            '<span class="sub-empty-row"><i class="fas fa-rocket"></i> ' + T('profile.noSub') + '</span>' +
            '<button class="btn btn-sm sub-cta" onclick="openPlansModal()"><i class="fas fa-rocket"></i> ' + T('hub.plans') + '</button>' +
            '</div>';
    }
    var info = (typeof PLAN_INFO !== 'undefined' && PLAN_INFO[plan]) || {};
    var maxClubs = (typeof planClubLimit === 'function') ? planClubLimit(plan) : Infinity;
    var owned = (typeof countMyOwnedClubs === 'function') ? countMyOwnedClubs() : 0;
    var clubsTxt = (maxClubs === Infinity) ? (owned + ' · ∞') : (owned + '/' + maxClubs);
    var membersTxt = (info.members === Infinity || info.members == null) ? '∞' : info.members;
    var badge = (typeof planTagHtml === 'function') ? planTagHtml({ plan: plan }) : '';
    var u = state.userSub || {};
    var cpe = u.current_period_end ? new Date(u.current_period_end) : null;
    /* Z5-F: zile rămase = ceil (cât timp mai ai acces azi, e „≥1 zi"). Data afișată prin
       toLocaleDateString (respectă fusul + localizarea browserului) în loc de getDate()
       manual care se deplasa cu o zi la fusuri extreme. */
    var daysLeft = cpe ? Math.max(0, Math.ceil((cpe.getTime() - Date.now()) / 86400000)) : null;
    var dateStr = cpe ? cpe.toLocaleDateString() : '';
    var autoRenew = !u.cancel_at_period_end;
    /* Formulare clară: cu auto-renew ON e o REÎNNOIRE, nu o expirare. */
    var daysLabel = autoRenew ? T('sub.renewsInDays') : T('sub.daysLeft');

    var rows =
        '<div class="sub-line"><span class="sub-k"><i class="fas fa-layer-group"></i> ' + T('profile.clubsUsed') + '</span><span class="sub-v">' + clubsTxt + '</span></div>' +
        '<div class="sub-line"><span class="sub-k"><i class="fas fa-users"></i> ' + T('profile.membersPerClub') + '</span><span class="sub-v">' + membersTxt + '</span></div>';
    if (cpe) {
        rows += '<div class="sub-line"><span class="sub-k"><i class="fas fa-sync-alt"></i> ' + T('sub.autoRenew') + '</span>' +
            '<span class="sub-v" style="color:' + (autoRenew ? 'var(--success,#27ae60)' : 'var(--accent-primary,#ff6b35)') + ';">' + (autoRenew ? T('sub.on') : T('sub.off')) + '</span></div>' +
            '<div class="sub-note">' + dateStr + (daysLeft != null ? ' · ' + daysLeft + ' ' + daysLabel : '') + '</div>';
    }

    var actions = '<div class="sub-actions">' +
        '<button class="btn btn-sm btn-secondary" onclick="openPlansModal()">' + T('profile.manageSub') + '</button>' +
        (cpe ? '<button class="btn btn-sm ' + (autoRenew ? 'btn-secondary' : 'btn-success') + '" onclick="toggleAutoRenew(' + (autoRenew ? 'false' : 'true') + ')">' +
            (autoRenew ? '<i class="fas fa-pause"></i> ' + T('sub.turnOff') : '<i class="fas fa-rotate-right"></i> ' + T('sub.turnOn')) + '</button>' : '') +
        '</div>';

    return '<div class="sub-card">' +
        '<div class="sub-title"><i class="fas fa-rocket"></i> ' + T('profile.mySub') + badge + '</div>' +
        '<div class="sub-rows">' + rows + '</div>' +
        actions +
        '</div>';
}

function toggleSettingsPanel(anchorEl) {
    var panel = document.getElementById('settingsPanel');
    if (!panel) return;
    if (panel.classList.contains('hidden')) {
        closeHeaderPopups('settingsPanel');
        /* ⚠ Panoul se ancorează sub butonul care l-a DESCHIS. Butonul din antet
           (`#settingsBtn`) e ASCUNS în hub, iar un panou ancorat de un element
           invizibil apare rupt de butonul apăsat. Parametrul e opțional, deci
           apelul existent din index.html rămâne valid.
           EN: anchor to whichever button opened it; the header button is hidden
               in the hub, and anchoring to an invisible element misplaces it. */
        window._settingsAnchor = anchorEl || null;
        panel.classList.remove('hidden');
        renderSettingsContent();
    } else {
        panel.classList.add('hidden');
    }
}

/* (Re)randează conținutul dinamic al Setărilor — apelat și la schimbarea limbii, pt. update live */
function renderSettingsContent() {
    var panel = document.getElementById('settingsPanel');
    if (!panel || panel.classList.contains('hidden')) return;
    var sub = document.getElementById('settingsSubSection');
    if (sub) {
        sub.innerHTML = (typeof settingsSubHTML === 'function') ? settingsSubHTML() : '';
        // butoanele de abonament deschid un modal -> închidem întâi popup-ul ca modalul să fie deasupra
        sub.querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () { panel.classList.add('hidden'); }); });
    }
    if (typeof anchorPopup === 'function') anchorPopup(panel, window._settingsAnchor || document.getElementById('settingsBtn'));
}


/* Profil din header: în hub deschide popup-ul, în club deschide tab-ul */
function openProfileFromHeader() {
    var hub = document.getElementById('clubHub');
    if (hub && !hub.classList.contains('hidden') && typeof openMyProfileModal === 'function') openMyProfileModal();
    else switchTab('profile');
}

/* Strip „tu — online" (fallback când nu există prezență de club, ex. în hub) */
function selfOnlinePresenceHtml() {
    if (!state.currentUser) return '';
    var esc = function (s) { return window.escHtml(s); };
    var T = (typeof t === 'function') ? t : function (k) { return k; };
    return '<span><span class="op-dot"></span>1 ' + T('dash.memberOne') + ' ' + T('dash.online') + '</span>' +
        '<span class="op-user">' + esc(state.currentUser.name || '') + (state.currentUser.isAdmin ? ' 👑' : '') + ' ' + T('dash.you') + '</span>';
}

function onlineCount() {
    var n = (window._lastOnlinePresence || []).filter(function (u) { return u && u.name; }).length;
    if (n === 0 && state.currentUser) n = 1; // ești online chiar și fără club
    return n;
}

function refreshOnlineBadge() {
    var badge = document.getElementById('onlineBadge');
    var n = onlineCount();
    if (badge) { badge.textContent = n; badge.classList.toggle('hidden', n === 0); }
    var panel = document.getElementById('onlinePanel');
    var empty = document.getElementById('onlineEmpty');
    if (panel && !panel.classList.contains('hidden') && empty) {
        var strip = document.getElementById('onlinePresence');
        var hasUsers = !!(strip && !strip.classList.contains('hidden') && strip.innerHTML.trim() !== '');
        empty.classList.toggle('hidden', hasUsers);
    }
}
window.refreshOnlineBadge = refreshOnlineBadge;

function toggleOnlinePanel() {
    var panel = document.getElementById('onlinePanel');
    if (!panel) return;
    if (panel.classList.contains('hidden')) {
        closeHeaderPopups('onlinePanel');
        if (typeof renderOnlinePresence === 'function') { try { renderOnlinePresence(); } catch (e) { logError('toggleOnlinePanel', e); } }
        var strip = document.getElementById('onlinePresence');
        var empty = document.getElementById('onlineEmpty');
        var hasUsers = !!(strip && !strip.classList.contains('hidden') && strip.innerHTML.trim() !== '');
        if (!hasUsers && strip && state.currentUser) {
            // fără prezență de club (ex. în hub) -> arată-te pe tine ca online
            strip.innerHTML = selfOnlinePresenceHtml();
            strip.classList.remove('hidden');
            hasUsers = true;
        }
        if (empty) empty.classList.toggle('hidden', hasUsers);
        panel.classList.remove('hidden');
        if (typeof anchorPopup === 'function') anchorPopup(panel, document.getElementById('onlineBtn'));
    } else {
        panel.classList.add('hidden');
    }
}

/* Badge online live: observă #onlinePresence (ținut la zi de renderOnlinePresence) */
(function initOnlineBadge() {
    function attach() {
        var strip = document.getElementById('onlinePresence');
        if (strip) { try { new MutationObserver(refreshOnlineBadge).observe(strip, { childList: true, subtree: true }); } catch (e) { logError('attach', e); } }
        refreshOnlineBadge();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach);
    else attach();
})();

/* Închide popup-urile header la click în afară (și păstrează doar pe cel apăsat) */
document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.header-popup')) return;
    /* ⚠ Butonul de Setări din hub NU e în `#headerActions`, deci ar fi căzut pe
       `closeHeaderPopups()` de la final și ar fi închis panoul în aceeași apăsare
       care tocmai l-a deschis. Îl exceptăm după atributul lui, nu după poziție.
       EN: the hub settings button lives outside the header, so the generic
           close-on-outside-click would shut the panel it just opened. */
    if (e.target.closest && e.target.closest('[data-keeps-popup]')) return;
    var btn = e.target.closest && e.target.closest('#headerActions button');
    if (btn) {
        var map = { clubSwitcher: 'clubMenu', notifBell: 'notifPanel', onlineBtn: 'onlinePanel', settingsBtn: 'settingsPanel' };
        closeHeaderPopups(map[btn.id]);
        return;
    }
    closeHeaderPopups();
});

function switchTab(tabName, event) {
    // Gating declarativ pe rol: dacă tab-ul are data-cap pe care userul nu o are -> redirect
    /* EXCEPȚIE (§2): un membru poate deschide tab-ul „Sesiune" în mod DOAR-VIZUALIZARE,
       ca să urmărească o sesiune live la care participă. Tab-ul e gardat pe
       `session.create` (rang>=2) fiindcă acolo se CREEAZĂ sesiuni — dar a CITI una
       existentă e permis oricărui membru. `_liveReadOnly` blochează toate câmpurile,
       iar serverul respinge oricum orice scriere. Nu e o portiță: e o cale explicită. */
    const _liveRead = (tabName === 'session' && window._liveReadOnly === true);
    /* Ieșim din modul doar-vizualizare când plecăm din tab -> nu rămâne agățat și nu
       devine o portiță permanentă spre un tab la care userul n-are acces. */
    if (tabName !== 'session' && window._liveReadOnly) {
        window._liveReadOnly = false;
        window._liveSessionId = null;
        try { if (typeof applyLiveReadOnly === 'function') applyLiveReadOnly(); } catch (e) { logError('switchTab', e); }
    }
    if (!_liveRead && typeof canAccessTab === 'function' && !canAccessTab(tabName)) {
        if (typeof showNotification === 'function') showNotification(t('rbac.noPermission'), 'error');
        tabName = 'dashboard';
        event = null;
    }
    // Update tabs
    document.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
    if (event) {
        event.currentTarget.classList.add('active');
    } else {
        document.querySelector(`[data-tab="${tabName}"]`).classList.add('active');
    }
    
    // Update tab content
    document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
    document.getElementById(`tab-${tabName}`).classList.add('active');
    
    currentTab = tabName;
    
    // Render specific content
    switch(tabName) {
        case 'dashboard': renderDashboard(); try { if (typeof renderLiveSessionsBar === 'function') renderLiveSessionsBar(); } catch (e) { logError('switchTab', e); } break;
        case 'profile': renderMyProfile(); break;
        case 'session':
            /* ⚠ NU reseta formularul dacă ai lucru în curs. Tab-urile sunt div-uri ascunse,
               deci DOM-ul (scorurile tastate) supraviețuiește comutării — singurul care le
               ștergea era `renderSessionForm()`, chemat la fiecare intrare în tab.
               `renderSessionPlayers` păstrează valorile (are snapshot/restore intern). */
            if (typeof sessionFormHasWork === 'function' && sessionFormHasWork()) {
                if (typeof renderSessionPlayers === 'function') renderSessionPlayers();
            } else {
                renderSessionForm();
            }
            try { if (typeof renderLiveSessionsBar === 'function') renderLiveSessionsBar(); } catch (e) { logError('switchTab', e); }
            break;
        case 'players': renderPlayers(); break;
        case 'catalog': renderCatalog(); break;
        case 'randomizers': renderRandomizers(); break;
        case 'history': renderHistory(); break;
        case 'polls':
            /* 8.16-3d: polls.js (sondajele + „Ce jucăm") se încarcă la cerere (KB §75.4) — încarcă, apoi
               desenează. Direct doar un modul de ACEEAȘI versiune (TO_CHAT.readyModule, KB §81.12). */
            if (window.TO_CHAT && window.TO_CHAT.readyModule && window.TO_CHAT.readyModule('TO_POLLS')) renderPolls();
            else if (window.TO_CHAT && window.TO_CHAT.useModule) window.TO_CHAT.useModule('polls.js', 'TO_POLLS', () => { if (currentTab === 'polls') renderPolls(); });
            break;
        case 'chat': loadChat(); break;
        case 'calendar': renderCalendar(); break;
        case 'stats': renderStats(); break;
        case 'regulation':
            /* R2 (31 oct. 2026): regulation.js se încarcă la cerere (KB §75.4) — încarcă, apoi desenează. Direct
               doar un modul de ACEEAȘI versiune (TO_CHAT.readyModule, KB §81.12). */
            if (window.TO_CHAT && window.TO_CHAT.readyModule && window.TO_CHAT.readyModule('TO_REG')) renderRegulation();
            else if (window.TO_CHAT && window.TO_CHAT.useModule) window.TO_CHAT.useModule('regulation.js', 'TO_REG', () => { if (currentTab === 'regulation') renderRegulation(); });
            break;
        case 'campaigns': renderCampaigns(); break;
        case 'tournaments':
            /* v9 8.3: tournaments.js se încarcă la cerere (KB §75.4) — încarcă, apoi desenează. */
            if (typeof renderTournaments === 'function') renderTournaments();
            else if (window.TO_CHAT && window.TO_CHAT.useModule) window.TO_CHAT.useModule('tournaments.js', 'TO_TOURN', () => { if (currentTab === 'tournaments') renderTournaments(); });
            break;
        case 'admin': renderAdmin(); break;
    }
    
    // Update URL hash
    window.location.hash = tabName;
    
    // Save last active tab
    localStorage.setItem('lastTab', tabName);
}

/* Buton Back (browser/mobil): navighează între meniuri (tab-uri) folosind hash-ul.
   Fiecare schimbare de tab adaugă o intrare în istoric, deci Back revine la meniul anterior. */
window.addEventListener('hashchange', function () {
    const h = (window.location.hash || '').replace(/^#/, '');
    if (!h) return;
    const mainApp = document.getElementById('mainApp');
    if (!mainApp || mainApp.classList.contains('hidden')) return;
    if (h !== currentTab && document.getElementById('tab-' + h)) {
        try { switchTab(h); } catch (e) { logError('switchTab', e); }
    }
});

/* ===================== PWA: service worker + instalare ===================== */
if ('serviceWorker' in navigator) {
    window.addEventListener('load', function () {
        navigator.serviceWorker.register('sw.js').then(function (reg) {
            /* Detectare actualizare: un SW nou + există deja un controller
               (deci nu e prima instalare) -> arată pop-up „Actualizează".
               ★ T-1 (29 oct. 2026): bannerul apare doar dacă pagina NU rulează deja versiunea nouă.
               De la T-1, prima încărcare după un deploy ia scripturile noi din rețea, iar SW-ul nou
               se instalează abia după ⇒ fără verificare, bannerul cerea o reîncărcare inutilă. După
               activare SW-ul nou a șters cache-urile vechi: dacă `TO_RELEASE` (versiunea paginii)
               nu mai are cache, pagina e veche ⇒ banner. Fără `caches` ⇒ banner, ca înainte.
               EN: show the banner only when the page is older than the newly activated SW. */
            function watch(w) {
                if (!w) return;
                var hadCtl = !!navigator.serviceWorker.controller;
                w.addEventListener('statechange', function () {
                    if (!hadCtl || w.state !== 'activated') return;
                    var rel = window.TO_RELEASE;
                    if (!window.caches || typeof rel !== 'string' || !/^turnorder-[a-z0-9]+$/.test(rel)) { _toShowUpdateBanner(w); return; }
                    caches.has(rel).then(function (has) { if (!has) _toShowUpdateBanner(w); }, function () { _toShowUpdateBanner(w); });
                });
            }
            /* 29 oct. 2026: un SW nou deja „în așteptare" când se încarcă pagina (reîncărcare rapidă
               imediat după un deploy) arăta bannerul DIRECT, fără verificarea de mai sus ⇒ apărea și
               când pagina rula deja versiunea nouă (văzut în browser, după T-1). Acum îl urmărim la
               fel și îl activăm (sw.js oricum sare peste așteptare la instalare). La fel unul încă „în
               instalare": `updatefound` a trecut înainte să ascultăm. Bannerul apare o singură dată.
               EN: a worker already waiting / installing at load goes through the same version check. */
            if (reg.waiting && navigator.serviceWorker.controller) {
                watch(reg.waiting);
                try { reg.waiting.postMessage({ type: 'SKIP_WAITING' }); } catch (e) { logError('watch', e); }
            }
            if (reg.installing && navigator.serviceWorker.controller) watch(reg.installing);
            reg.addEventListener('updatefound', function () { watch(reg.installing); });
            setInterval(function () { try { reg.update(); } catch (e) { logError('watch', e); } }, 60 * 60 * 1000); // verifică din oră în oră
        }).catch(function (e) { console.warn('SW:', e && e.message); });

        /* Nudge de instalare. Android: prin beforeinstallprompt (apare doar dacă NU e instalată).
           iOS: nu există acel eveniment -> încercăm după load (o singură dată). */
        setTimeout(function () { try { if (_toIsIosUA()) maybeShowInstallHint(); } catch (e) { logError('watch', e); } }, 2200);
    });
}
let _deferredInstallPrompt = null;
window.addEventListener('beforeinstallprompt', function (e) {
    e.preventDefault();
    _deferredInstallPrompt = e;
    const b = document.getElementById('pwaInstallBtn'); if (b) b.style.display = '';
    /* beforeinstallprompt apare DOAR dacă aplicația nu e instalată -> putem arăta nudge-ul. */
    try { maybeShowInstallHint(); } catch (e2) { logError('watch', e2); }
});
window.addEventListener('appinstalled', function () {
    _deferredInstallPrompt = null;
    const b = document.getElementById('pwaInstallBtn'); if (b) b.style.display = 'none';
    try { showNotification(t('core.appInstalled'), 'success'); } catch (e) { logError('watch', e); }
    /* La instalare, cere imediat permisiunea de notificări (prompt de sistem). */
    try { if (typeof maybeAutoPromptPush === 'function') setTimeout(maybeAutoPromptPush, 800); } catch (e) { logError('watch', e); }
});
/* RO: Butonul din hub (`#pwaInstallBtn`, renderClubHub) e acum PERMANENT — ascuns
       doar când rulăm deja ca aplicație instalată (`_toIsStandalone()`), unde chiar
       n-are sens. Înainte apărea numai dacă `_deferredInstallPrompt` era deja
       salvat, adică depindea de `beforeinstallprompt` — un eveniment al browserului
       care la prima vizită poate să nu sosească deloc (Chrome evaluează
       instalabilitatea înainte ca SW-ul, înregistrat în handlerul `load`, să fie
       gata). `installPwa()` are cale de rezervă cu instrucțiuni manuale, deci
       butonul e util și fără promptul nativ.
   EN: the hub install button is now permanent, hidden only in standalone mode;
       it no longer depends on `beforeinstallprompt`, which may never fire. */
async function installPwa() {
    if (!_deferredInstallPrompt) {
        showNotification(t('core.installHint'), 'info');
        return;
    }
    _deferredInstallPrompt.prompt();
    /* ⚠ Ascundem butonul DOAR dacă instalarea a fost acceptată. Înainte se ascundea
       necondiționat, deci cine ANULA promptul rămânea fără buton până la refresh —
       tocmai cazul în care ar vrea să reîncerce. */
    let accepted = false;
    try { const c = await _deferredInstallPrompt.userChoice; accepted = !!(c && c.outcome === 'accepted'); }
    catch (e) { logError('installPwa', e); }
    _deferredInstallPrompt = null; /* promptul salvat e de unică folosință */
    if (accepted) { const b = document.getElementById('pwaInstallBtn'); if (b) b.style.display = 'none'; }
}

/* ---------- Pop-up-uri „Instalează" / „Actualizează" aplicația ---------- */
function _toIsStandalone() {
    return (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches)
        || window.navigator.standalone === true;
}
function _toIsMobileUA() { return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || ''); }
function _toIsIosUA() { return /iPhone|iPad|iPod/i.test(navigator.userAgent || ''); }

/* Bară jos, dismisibilă, cu buton opțional și auto-ascundere opțională. */
function showAppBanner(opts) {
    try {
        var ex = document.getElementById(opts.id); if (ex) ex.remove();
        var bar = document.createElement('div');
        bar.id = opts.id; bar.className = 'to-app-banner';
        var act = opts.actionLabel
            ? '<button type="button" class="to-app-banner-btn" id="' + opts.id + '-act"></button>' : '';
        bar.innerHTML =
            '<img class="to-app-banner-ico" src="./icon-192.png" alt="">'
          + '<div class="to-app-banner-txt"></div>'
          + act
          + '<button type="button" class="to-app-banner-x" aria-label="x">&times;</button>';
        /* text/etichete setate prin textContent/innerHTML controlat (fără injecție de la user) */
        bar.querySelector('.to-app-banner-txt').innerHTML = opts.html || '';
        if (opts.actionLabel) bar.querySelector('#' + opts.id + '-act').textContent = opts.actionLabel;
        document.body.appendChild(bar);
        requestAnimationFrame(function () { bar.classList.add('show'); });
        var hide = function () { bar.classList.remove('show'); setTimeout(function () { if (bar.parentNode) bar.remove(); }, 350); };
        var xb = bar.querySelector('.to-app-banner-x'); if (xb) xb.onclick = hide;
        if (opts.actionLabel) {
            var ab = bar.querySelector('#' + opts.id + '-act');
            if (ab) ab.onclick = function () { try { opts.onAction && opts.onAction(); } catch (e) { logError('showAppBanner', e); } if (opts.hideOnAction !== false) hide(); };
        }
        if (opts.autoHideMs) setTimeout(hide, opts.autoHideMs);
        return hide;
    } catch (e) { logError('showAppBanner', e); }
}

/* Prima vizită din browser pe mobil -> nudge „Descarcă aplicația" (o singură dată, auto-dispare).
   NU apare dacă aplicația rulează deja ca PWA (standalone) sau e deja instalată pe dispozitiv. */
async function maybeShowInstallHint() {
    if (_toIsStandalone() || !_toIsMobileUA()) return;            // rulează deja ca PWA sau nu e mobil
    try { if (localStorage.getItem('to_install_hint_v1') === '1') return; } catch (e) { logError('maybeShowInstallHint', e); }
    var isIos = _toIsIosUA();
    if (!isIos) {
        if (!_deferredInstallPrompt) return;                      // fără prompt -> probabil deja instalată
        try {
            if (navigator.getInstalledRelatedApps) {
                var apps = await navigator.getInstalledRelatedApps();
                if (apps && apps.length) return;                  // confirmat: deja instalată
            }
        } catch (e) { logError('maybeShowInstallHint', e); }
    }
    try { localStorage.setItem('to_install_hint_v1', '1'); } catch (e) { logError('maybeShowInstallHint', e); }
    var tt = (typeof t === 'function') ? t : function (k) { return k; };
    var html = tt('install.banner') + (isIos ? ' <span class="to-app-banner-hint">' + tt('install.iosHint') + '</span>' : '');
    showAppBanner({
        id: 'toInstallBanner', html: html,
        actionLabel: isIos ? null : tt('install.btn'),
        onAction: isIos ? null : installPwa,
        autoHideMs: 7000
    });
}

/* Versiune nouă detectată -> pop-up „Actualizează" (rămâne până apeși; aplică + reîncarcă). */
function _toShowUpdateBanner(worker) {
    if (window._toUpdateShown) return; window._toUpdateShown = true;
    var tt = (typeof t === 'function') ? t : function (k) { return k; };
    showAppBanner({
        id: 'toUpdateBanner', html: tt('update.banner'),
        actionLabel: tt('update.btn'),
        hideOnAction: false,
        onAction: function () {
            try { worker.postMessage({ type: 'SKIP_WAITING' }); } catch (e) { logError('_toShowUpdateBanner', e); }  // siguranță, dacă mai aștepta
            setTimeout(function () { window.location.reload(); }, 120);           // SW-ul nou e deja activ -> încarcă versiunea nouă
        }
    });
}

function render() {
    if (!state.currentUser) return; // nu randa UI sensibil fără user logat
    updateTabBadges();
    renderDashboard();
    if (typeof renderSessionRefresh === 'function') renderSessionRefresh(); else renderSessionForm();
    renderPlayers();
    renderCatalog();
    renderRandomizers();
    renderHistory();
    /* 8.16-3d: polls.js e la cerere — fără el (tabul „Sondaje" nedeschis) nu e nimic de desenat. */
    if (window.TO_CHAT && window.TO_CHAT.readyModule && window.TO_CHAT.readyModule('TO_POLLS')) renderPolls();
    renderCalendar();
    renderStats();
    renderEloLeaderboard();
    renderAchievements();
    /* R2: regulation.js e la cerere — fără el (tabul „Regulament" nedeschis) nu e nimic de desenat. */
    if (window.TO_CHAT && window.TO_CHAT.readyModule && window.TO_CHAT.readyModule('TO_REG')) renderRegulation();
    renderCampaigns();
    renderAdmin();
    if (typeof renderMyProfile === 'function') renderMyProfile();
    if (typeof renderClubReadonlyBanner === 'function') renderClubReadonlyBanner();
    if (typeof applyRoleUIGating === 'function') applyRoleUIGating();
    if (typeof applyPlanGating === 'function') applyPlanGating();
    renderNotifBadge();
}

function updateTabBadges() {
    // Dashboard badge
    const totalGames = state.games.length;
    document.getElementById('tabBadgeDashboard').textContent = totalGames;
    
    // Players badge
    const _msrcPB = (state.membersById && Object.keys(state.membersById).length) ? state.membersById : (state.members || {});
    const activePlayers = Object.values(_msrcPB).filter(m => !m.hidden).length;
    document.getElementById('tabBadgePlayers').textContent = activePlayers;
    
    // Catalog badge
    const totalGamesCatalog = Object.keys(state.catalog).length;
    document.getElementById('tabBadgeCatalog').textContent = totalGamesCatalog;
    
    // History badge
    const recentGames = state.games.filter(g => {
        const gameDate = new Date(g.timestamp);
        const weekAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
        return gameDate > weekAgo;
    }).length;
    document.getElementById('tabBadgeHistory').textContent = recentGames;
    
    // Polls badge
    const activePolls = state.polls.filter(p => p.active && new Date(p.expiresAt) > new Date()).length;
    document.getElementById('tabBadgePolls').textContent = activePolls;
    
    // Chat badge
    const unreadMessages = state.chatMessages.filter(m => {
        return m.senderEmail !== state.currentUser?.email && 
               new Date(m.timestamp) > new Date(state.currentUser?.lastLogin || 0);
    }).length;
    document.getElementById('tabBadgeChat').textContent = unreadMessages > 0 ? unreadMessages : '';

    // Campaigns badge (campanii în desfășurare)
    const cb = document.getElementById('tabBadgeCampaigns');
    if (cb) { const act = (state.campaigns || []).filter(c => c.status === 'active').length; cb.textContent = act > 0 ? act : ''; }
}


/* ---------- Închide orice modal/popup la click pe fundal (alternativă la „×") ---------- */
document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.classList) return;
    if (t.classList.contains('modal') && t.classList.contains('active')) {
        /* ⚠ Daca modalul si-a definit propria inchidere (`__dispose`), o RESPECTAM. Altfel
           acest handler ii scotea clasa `active` direct din DOM, sarind peste ea: modalul
           devenea invizibil desi logic era inca deschis, iar curatenia lui (redenumiri de
           id-uri, rezolvarea unei promisiuni, o intrebare „ai modificari nesalvate?") nu se
           mai facea niciodata. La profilul propriu, asta lasa un `#myProfileContent` duplicat
           in pagina, iar redeschiderea aparea GOALA.
           `_disposeModal` face deja alegerea corecta pentru fiecare tip de modal.
           EN: respect a modal's own dispose hook instead of stripping `active` behind its back. */
        if (typeof t.__dispose === 'function') {
            try { _disposeModal(t); } catch (_) { logError('modalBackdropClose', _); }
            return;
        }
        t.classList.remove('active');
        if (t.dataset && t.dataset.dynamic === '1') { try { t.remove(); } catch (_) { logError('updateTabBadges', _); } }
    }
    if (t.id === 'feedbackModal') { try { if (typeof closeFeedback === 'function') closeFeedback(); } catch (_) { logError('updateTabBadges', _); } }
});
